/* Swim Tether Kit Configurator v2.0 â€” Dynamic pricing from Shopify variants */
(function () {
  "use strict";
  var h = React.createElement;
  var useState = React.useState;
  var useRef = React.useRef;
  var useEffect = React.useEffect;

  var REQUIRE_ACCESS_CODE = false;
  var ACCESS_CODE = "";

  /* â•â•â• Shopify variant data (injected by configurator.liquid) â•â•â• */
  var SV = window.ST_VARIANTS || { poles: {}, bases: {}, cords: {} };

  /* SKU mapping: configurator keys â†’ Shopify SKUs */
  var SKU_MAP = {
    poles: {
      ST1_standard: "ST1-POLE",
      ST1_narrow: "ST1N-POLE",
      ST2_standard: "ST2-POLE",
      ST2_narrow: "ST2N-POLE",
      ST3_standard: "ST3-POLE",
      ST3_narrow: "ST3N-POLE",
    },
    bases: {
      concrete: "BASE-CB",
      threaded: "BASE-TB-1",
      arctic: "BASE-AA",
      uha_cs: "UHA-CS",
      uha_bz: "UHA-BZ",
    },
    cords: {
      4.5: "CORD-45",
      6: "CORD-06",
      8: "CORD-08",
      10: "CORD-10",
      12: "CORD-12",
      14: "CORD-14",
      16: "CORD-16",
      18: "CORD-18",
      20: "CORD-20",
    },
    accessories: { belt: "ACC-BELT", bag: "ACC-BAG" },
  };

  /* Hardcoded variant IDs (fallback when ST_VARIANTS not injected) */
  var VARIANT_IDS = {
    "ST3-POLE": 44838948569295,
    "ST3N-POLE": 44838948602063,
    "ST2-POLE": 44838950076623,
    "ST2N-POLE": 44838950109391,
    "ST1-POLE": 44838951026895,
    "ST1N-POLE": 44838951059663,
    "BASE-CB": 44838952042703,
    "BASE-TB-1": 44838952730831,
    "BASE-AA": 44838958006479,
    "UHA-CS": 45594241007823,
    "UHA-BZ": 45594241040591,
    "CORD-45": 44838942015695,
    "CORD-06": 44838942048463,
    "CORD-08": 44838942081231,
    "CORD-10": 44838942113999,
    "CORD-12": 44838942146767,
    "CORD-14": 44838942179535,
    "CORD-16": 44838942212303,
    "CORD-18": 44838942245071,
    "CORD-20": 44838942277839,
    "ACC-BELT": 44838960005327,
    "ACC-BAG": 44838959382735,
  };

  /* Price lookups with hardcoded fallbacks */
  function polePrice(model, fitting) {
    var sku = SKU_MAP.poles[model + "_" + (fitting || "standard")];
    var v = sku && SV.poles[sku];
    return v ? v.price : { ST1: 215, ST2: 255, ST3: 299 }[model] || 0;
  }
  function poleVariantId(model, fitting) {
    var sku = SKU_MAP.poles[model + "_" + (fitting || "standard")];
    var v = sku && SV.poles[sku];
    return v ? v.id : VARIANT_IDS[sku] || 0;
  }
  function basePrice(id) {
    var sku = SKU_MAP.bases[id];
    var v = sku && SV.bases[sku];
    return v
      ? v.price
      : { concrete: 10, threaded: 10, arctic: 10, uha_cs: 40, uha_bz: 40 }[
          id
        ] || 0;
  }
  function baseVariantId(id) {
    var sku = SKU_MAP.bases[id];
    var v = sku && SV.bases[sku];
    return v ? v.id : VARIANT_IDS[sku] || 0;
  }
  function cordPriceFromShopify(len) {
    var sku = SKU_MAP.cords[String(len)];
    var v = sku && SV.cords[sku];
    return v ? v.price : cordPriceFallback(len);
  }
  function cordVariantId(len) {
    var sku = SKU_MAP.cords[String(len)];
    var v = sku && SV.cords[sku];
    return v ? v.id : VARIANT_IDS[sku] || 0;
  }
  function cordPriceFallback(len) {
    return len > 8 ? 2 + (len - 8) * 2 : 0;
  }

  /* ═══ Pending discount code (fix-it #87) ═══
     A /discount/<CODE> link (the Pickens DRAGONS QR, ERIK25-style courtesy
     codes, the WELCOME15 wrapper) leaves a `discount_code` cookie that the cart
     applies, so Review used to show full price until the cart. Review now asks
     Shopify to price this exact kit with the code (Storefront API cartCreate on
     a throwaway cart): the discount shown is Shopify's own math, no code terms
     live in the theme, and a code that doesn't apply here (other market,
     expired) shows nothing. The probe runs in a Worker because the storefront's
     analytics wrap window.fetch to report cart writes, and a price check must
     never count as an add-to-cart. */
  var PROMO_API = "/api/2026-10/graphql.json";
  var PROMO_QUERY =
    "mutation($input: CartInput!, $country: CountryCode) @inContext(country: $country) {" +
    " cartCreate(input: $input) { cart { discountCodes { code applicable }" +
    " discountAllocations { ...A } lines(first: 10) { nodes { discountAllocations { ...A } } } } } }" +
    " fragment A on CartDiscountAllocation { discountedAmount { amount } ... on CartCodeDiscountAllocation { code } }";
  var PROMO_WORKER =
    "onmessage=function(e){fetch(e.data.u,{method:'POST',headers:{'Content-Type':'application/json'},body:e.data.b})" +
    ".then(function(r){return r.ok?r.json():null}).then(function(j){postMessage(j)},function(){postMessage(null)})}";
  var promoCache = {};

  function cookieCodes() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || "");
    if (!m) return [];
    var v = m[1];
    try {
      v = decodeURIComponent(v);
    } catch (e) {}
    return v
      .split(",")
      .map(function (c) {
        return c.trim();
      })
      .filter(Boolean);
  }

  /* → { applied: ["DRAGONS"], rows: [{ code, amount }], saved } */
  function parsePromo(d) {
    var cart = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
    if (!cart) return null;
    var by = {},
      order = [];
    function add(a) {
      var amt = parseFloat(a.discountedAmount && a.discountedAmount.amount) || 0;
      if (!a.code || !amt) return;
      if (!(a.code in by)) {
        by[a.code] = 0;
        order.push(a.code);
      }
      by[a.code] += amt;
    }
    (cart.discountAllocations || []).forEach(add);
    ((cart.lines && cart.lines.nodes) || []).forEach(function (n) {
      (n.discountAllocations || []).forEach(add);
    });
    var rows = order.map(function (c) {
      return { code: c, amount: Math.round(by[c] * 100) / 100 };
    });
    return {
      applied: (cart.discountCodes || [])
        .filter(function (c) {
          return c.applicable;
        })
        .map(function (c) {
          return c.code;
        }),
      rows: rows,
      saved: rows.reduce(function (s, r) {
        return Math.round((s + r.amount) * 100) / 100;
      }, 0),
    };
  }

  /* cb(result) — null when the price check couldn't run. */
  function probePromo(items, codes, cb) {
    var country = (window.Shopify && Shopify.country) || null;
    var lines = items.map(function (i) {
      return {
        merchandiseId: "gid://shopify/ProductVariant/" + i.id,
        quantity: i.quantity,
      };
    });
    var key = JSON.stringify([lines, codes, country]);
    if (promoCache[key]) return cb(promoCache[key]);
    var url, w;
    try {
      url = URL.createObjectURL(
        new Blob([PROMO_WORKER], { type: "text/javascript" }),
      );
      w = new Worker(url);
    } catch (e) {
      return cb(null);
    }
    var done = false;
    function finish(res) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      w.terminate();
      URL.revokeObjectURL(url);
      if (res) promoCache[key] = res;
      cb(res);
    }
    var timer = setTimeout(function () {
      finish(null);
    }, 8000);
    w.onmessage = function (e) {
      finish(parsePromo(e.data));
    };
    w.onerror = function () {
      finish(null);
    };
    w.postMessage({
      u: location.origin + PROMO_API,
      b: JSON.stringify({
        query: PROMO_QUERY,
        variables: {
          country: country,
          input: { lines: lines, discountCodes: codes },
        },
      }),
    });
  }

  /* ═══ Kit SKU builder ═══ */
  /* Assembles a display-only kit SKU per v4 taxonomy: ST[model]-[cord]-[base] */
  var BASE_CODES = {
    concrete: "CB",
    threaded: "TB",
    arctic: "AA",
    uha_cs: "CS",
    uha_bz: "BZ",
  };
  function buildKitSKU(model, cord, base, narrow) {
    var m = model + (narrow ? "N" : "");
    var c = String(cord);
    if (c === "4.5") c = "45";
    else if (c.length === 1) c = "0" + c;
    if (!base || base === "have_base") return m + "-" + c;
    var bc = BASE_CODES[base] || "";
    return m + "-" + c + "-" + bc;
  }

  /* ═══ Parse kit SKU from URL param ═══ */
  /* Reverse of buildKitSKU: "ST3-08-CB" → {model:"ST3", cord:8, base:"concrete", narrow:false} */
  var BASE_REVERSE = {
    CB: "concrete",
    TB: "threaded",
    AA: "arctic",
    CS: "uha_cs",
    BZ: "uha_bz",
  };
  var CORD_REVERSE = {
    45: 4.5,
    "06": 6,
    "08": 8,
    10: 10,
    12: 12,
    14: 14,
    16: 16,
    18: 18,
    20: 20,
  };
  function parseKitSKU(sku) {
    if (!sku) return null;
    var s = sku.trim().toUpperCase();
    /* Match: ST + (model with optional N) + dash + (cord code) + optional dash + (base code) */
    var rx = /^ST(1N?|2N?|3N?)-(\d{2})(?:-([A-Z]{2}))?$/;
    var m = s.match(rx);
    if (!m) return null;
    var modelCode = m[1]; /* e.g. "3", "2N" */
    var cordCode = m[2]; /* e.g. "08", "45" */
    var baseCode = m[3] || null; /* e.g. "CB" or null */
    var cordLen = CORD_REVERSE[cordCode];
    if (cordLen === undefined) return null;
    if (baseCode && !BASE_REVERSE[baseCode]) return null;
    var narrow = modelCode.indexOf("N") !== -1;
    var model = "ST" + modelCode.replace("N", "");
    if (!MODELS[model]) return null;
    /* No base code in SKU → "using existing base" (pole-only kit). buildKitSKU
       emits exactly this form (e.g. "ST2-45") for a have_base build, so parse it
       back the same way: a complete, buyable config that jumps straight to Review.
       (Previously returned base:null / hasBase:false, which dumped shared pole-only
       links on the Base step instead of the review card — broke round-trip once the
       Pool/Swim-spa selector made Base an explicit step.) */
    return {
      model: model,
      cord: cordLen,
      base: baseCode ? BASE_REVERSE[baseCode] : "have_base",
      narrow: narrow,
      fitting: narrow ? "narrow" : "standard",
      hasBase: true,
    };
  }

  var C = {
    blue: "#0099FF",
    volt: "#CEFF00",
    carbon: "#3A3A3A",
    charcoal: "#4A4A4A",
    arctic: "#F5F5F5",
    graphite: "#1A1A1A",
    white: "#FFFFFF",
    red: "#FF4444",
    green: "#22C55E",
    ad: "#E8E8E8",
  };
  var f = "'Space Grotesk',sans-serif";
  var bf = "'DM Sans',sans-serif";
  var MODELS = {
    ST1: {
      name: "ST1 System",
      height: 23.75,
      flex: 6.5,
      droop: 1,
      desc: "Short & rigid \u2014 ideal for water aerobics and therapy",
      best: "Water aerobics, swim spas, therapy",
      minDist: 4,
    },
    ST2: {
      name: "ST2 System",
      height: 46.5,
      flex: 25,
      droop: 7,
      desc: "Versatile all-rounder for families and fitness swimmers",
      best: "Most pools, families, all-purpose",
      minDist: 5,
    },
    ST3: {
      name: "ST3 System",
      height: 69.38,
      flex: 39.5,
      droop: 11,
      desc: "Maximum flex for the smoothest, most natural swim feel",
      best: "Performance swimming, large pools",
      pop: true,
      minDist: 6,
    },
  };
  var MODEL_ORDER = ["ST3", "ST2", "ST1"];
  var BASES = [
    {
      id: "concrete",
      name: "Concrete Deck Base",
      desc: "Drill-in anchor for concrete, stone, or paver decks \u00B7 includes rubber plug \u00B7 sets with hydraulic cement (not included)",
      inc: true,
    },
    {
      id: "threaded",
      name: "Threaded Wood Deck Base",
      desc: "Threaded mount for wood or composite decking \u00B7 includes rubber plug",
    },
    {
      id: "uha_cs",
      name: "Screw-In Umbrella Hole Adapter",
      desc: "For composite umbrella sleeves (molded plastic — black, white, or tan) \u00B7 no drilling \u2014 screws right into the sleeve you already have \u00B7 base included",
    },
    {
      id: "uha_bz",
      name: "Drop-In Umbrella Hole Adapter",
      desc: "For cast bronze umbrella sleeves (solid metal, 2\u2033 bore) \u00B7 no drilling \u2014 drops in and lifts back out \u00B7 base included",
    },
    {
      id: "arctic",
      name: "Arctic Spa Adapter",
      desc: "For swim spas built by Arctic Spas only",
    },
    {
      id: "have_base",
      name: "I Already Have a Base Installed",
      desc: "I have an existing deck base and just need the pole, cord, and belt",
      existing: true,
    },
  ];
  /* Base cards follow product status: the Liquid injector skips draft/
     unpublished products, so absence from ST_VARIANTS.bases means "pulled
     from the store" and the card must not render (a hardcoded card would
     fall back to a stale price + variant id and then die at cart-add).
     have_base has no product behind it and always shows. (UHA pull,
     2026-07-22) */
  function baseIsLive(id) {
    var sku = SKU_MAP.bases[id];
    if (!sku) return true;
    return !!(SV.bases && SV.bases[sku]);
  }
  BASES = BASES.filter(function (b) {
    return baseIsLive(b.id);
  });
  var CORDS = [4.5, 6, 8, 10, 12, 14, 16, 18, 20];
  /* Pools never get a cord recommendation under 8 ft (Brent, 2026-10-11):
     on a 6 ft cord the swimmer floats back onto the wall, the steps or the
     shallow-end floor (ST-8515, ST-9047). calc() serves the pool path only;
     the swim-spa install picker sets its own cords. */
  var POOL_MIN_CORD_FT = 8;
  var WE = 1.24;
  var CORD_STRETCH = 0.3; /* 30% stretch for EPDM Shore-A 60 — visual diagram only */

  /* Swimmer silhouette SVG paths — original viewBox: 0 0 1171.966 291.406 */
  var SWIMMER_VB = {
    w: 1171.966,
    h: 291.406,
    cx: 550,
    cy: 155,
  }; /* cx/cy = approx waist center */
  var SWIMMER_PATHS = [
    "M1118.395,198.336c3.343,1.172,6.714,2.27,10.02,3.54,2.503.963,4.916,2.168,6.746,4.231,1.546,1.74,2.145,3.768,1.202,5.95-.965,2.232-2.971,3.021-5.258,2.983-3.848-.063-7.352-1.444-10.651-3.265-5.932-3.274-12.238-4.675-19.003-4.721-9.132-.062-17.217-2.792-23.157-10.249-2.816-3.535-6.719-3.609-10.753-3.254-16.615,1.463-32.637,5.981-48.841,9.532-20.527,4.498-41.38,5.537-62.266,6.326-2.309.087-4.77.204-6.931-.451-21.094-6.396-42.235-.415-63.329-.181-12.194.135-24.243.707-36.087-2.872-12.141-3.669-24.469-6.26-38.898-5.144,6.679-5.506,12.094-9.971,18.003-14.843-2.691-.418-4.064,1.07-5.474,1.977-24.936,16.027-49.972,31.88-76.332,45.522-17.461,9.036-35.391,17.007-53.784,23.933-17.654,6.646-35.993,9.19-54.734,7.951-31.875-2.107-63.533,1.665-95.277,3.028-6.259.269-12.216,2.5-18.045,4.811-31.059,12.312-63.142,19.126-96.701,18.181-22.952-.647-45.487-4.059-67.695-9.809-7.341-1.901-14.673-2.038-22.278-.993-13.122,1.804-25.818,1.012-37.484-6.981-6.871-4.708-15.532-5.162-23.698-5.813-23.156-1.845-46.136-5.079-69.128-8.232-21.783-2.987-43.496-2.247-65.097,1.463-29.677,5.097-59.711,7.789-89.303,13.425-2.074.395-4.081,1.206-6.079,1.935-5.016,1.832-8.016-.205-8.105-5.565-.106-6.343,4.643-12.332,11.095-13.107,3.162-.379,5.279-1.636,7.148-3.968,3.897-4.861,8.804-6.945,15.239-7.442,17.074-1.32,34.043-3.538,50.906-6.869,23.04-4.552,46.263-2.626,69.387.107,16.138,1.906,32.263,3.917,48.385,5.95,8.02,1.011,15.736,3.138,23.039,6.687,13.814,6.712,28.23,9.876,43.643,7.591,3.689-.547,7.436-.551,11.145.586,16.169,4.955,32.829,6.868,49.643,7.569,33.297,1.388,66.406-.896,99.389-5.395,1.748-.238,3.454-.779,5.133-1.668-15.545.79-31.083,1.774-46.636,2.331-29.106,1.041-58.219,1.829-87.172-2.561-1.233-.186-2.478-.381-3.674-.721-11.91-3.371-23.823-5.455-36.377-3.626-8.404,1.224-16.957-.595-24.505-4.398-17.964-9.051-37.286-11.754-56.901-13.615-15.821-1.502-31.62-3.236-47.434-4.809-19.353-1.926-38.478-.424-57.531,3.391-22.254,4.455-44.81,6.777-67.415,8.621-3.01.245-6.123.552-8.942,1.535-6.03,2.101-12.061,3.026-18.413,2.035-3.58-.559-7.127.176-10.596,1.079-2.809.731-5.423.722-7.119-2.01-1.606-2.588-2.141-5.513-.007-7.974,1.513-1.744,1.86-3.179.816-5.188-.7-1.348-.658-3.065.415-4.032,2.067-1.862,3.641-3.651,3.253-6.745-.152-1.21,1.074-2.218,2.46-2.437,1.827-.288,2.635-1.315,3.055-3.128.659-2.859,1.99-5.082,5.637-3.735.566.209,1.53.059,2.006-.314,9.863-7.732,22.197-8.419,33.594-11.663,7.981-2.273,15.549-5.112,22.356-9.932,5.277-3.736,10.949-6.728,17.383-8.011,9.995-1.992,20.314,3.899,23.638,13.367.478,1.363-.11,2.138-2.33,3.404,18.518-1.946,35.037-5.667,51.601-9.171,16.582-3.508,33.145-7.105,49.877-9.881,17.6-2.92,34.468.464,51.194,5.444,10.265,3.055,20.526,6.038,31.229,7.319,12.806,1.532,25.465.843,37.528-3.596,25.251-9.291,51.413-13.253,78.095-14.745,12.023-.672,23.052-4.273,32.996-11.269,8.345-5.87,17.275-10.749,26.948-14.143,20.378-7.151,40.616-7.069,59.596,3.654,21.604,12.205,40.621,6.72,58.57-6.968,12.24-9.335,22.332-21.062,32.801-32.309,3.392-3.644,6.303-9.176,10.403-10.3,3.771-1.033,8.841,2.721,13.352,4.33q11.532,4.116,10.374,16.143c-.622,6.374-1.295,12.745-1.38,19.142,2.55-16.22,10.505-32.341.902-48.81.181,4.694,2.23,9.219,1.45,14.918-8.659-3.512-17.186-6.499-25.305-10.35-25.783-12.232-52.069-23.516-75.956-39.434-5.416-3.61-11.537-5.656-18.094-6.052-20.839-1.255-40.829-6.17-60.472-13.121-16.046-5.679-32.611-9.201-49.8-9.099-6.617.039-11.678,2.294-16.563,7.083-7.185,7.044-14.798,13.726-26.041,14.409-5.723.347-11.301,3.117-16.623,5.673-1.782.856-3.537,2.199-5.363.434-1.978-1.913-1.559-4.215-.468-6.437,1.963-3.997,5.533-5.928,9.537-7.223,1.802-.582,3.664-.974,6.695-1.766-7.831-2.519-14.349-.897-20.813-.053-6.388.834-12.761,1.574-19.207,1.472-1.602-.026-3.218-.112-4.799-.359-2.378-.373-4.747-1.049-4.824-4.046-.075-2.926,2.07-3.968,4.513-4.369,6.305-1.036,12.625-1.973,18.835-3.986-5.488.558-10.972,1.164-16.466,1.656-2.66.238-5.353.479-8.005.315-2.119-.131-3.596-1.519-3.905-3.772-.324-2.362.942-3.936,3.054-4.346,3.122-.605,4.873-1.431,4.712-5.372-.128-3.109,3.494-3.706,6.027-4.325,6.738-1.642,13.532-3.056,21.512-4.831-4.105-1.219-6.781.506-9.562.489-1.664-.01-3.399.185-4.045-1.725-.708-2.097.633-3.336,2.328-4.252.312-.168.633-.357.972-.435,18.522-4.29,36.815-10.784,56.298-5.782,4.355,1.118,8.709,1.722,13.198.367,2.749-.83,5.635-.712,8.495-.159,16.227,3.141,32.656,3.484,49.101,3.326,25.378-.245,49.839,4.258,74.399,10.814,21.087,5.628,41.796,12.964,63.583,16.23,12.532,1.88,24.46,6.586,34.844,14.38,3.209,2.409,7.141,2.003,10.809,2.45,14.484,1.767,28.446,5.119,41.083,12.802,7.955,4.835,14.501,11.049,18.64,19.467,1.472,2.994,3.634,4.648,6.694,5.618,7.708,2.441,14.833,6.074,21.555,10.583,2.089,1.401,4.043,4.684,6.765,3.224,3.511-1.885,6.997-4.295,8.227-8.708,1.039-3.728.641-7.449.501-11.182-.404-10.711,1.926-20.509,8.898-29.005,2.111-2.572,3.127-2.915,5.433-.053,14.599,18.116,30.818,34.728,47.837,50.568,2.103,1.957,3.369,3.989,4.123,7.038,1.508,6.1,5.16,11.367,9.872,15.635,3.542,3.209,7.387,2.533,11.409.453,4.972-2.571,5.779-2.002,6.222,3.42.102,1.247.165,2.496.271,3.742.814,9.516.671,9.672-8.565,9.31-.531-.02-1.097-.137-1.59-.002-3.506.966-2.592,4.771-4.361,6.906-1.436,1.734-6.153-.493-5.007,4.307.405,1.697-.257,3.402-2.306,3.508-3.757.194-4.841,2.837-6.124,5.704-2.945,6.579-7.61,8.356-14.408,5.722-4.553-1.765-8.367-4.758-12.2-7.671-5.12-3.892-10.342-4.879-16.484-2.112-7.758,3.496-16.258,5.17-23.825,9.281,8.481-1.115,16.857-2.888,24.651-6.278,5.369-2.335,9.627-1.404,13.95,1.756,4.037,2.954,8.067,5.938,12.717,7.883,8.548,3.573,14.562,1.258,18.237-7.239,1.011-2.337,1.921-4.143,4.809-4.027,1.11.045,2.636-.505,2.59-1.479-.248-5.25,6.031-5.593,7.137-9.874.541-2.096,2.41-.834,3.585-.342,5.453,2.28,10.593,5.148,15.394,8.601,2.672,1.921,5.486,3.211,8.917,3.034,13.251-.685,26.449.174,39.528,2.2,10.326,1.6,20.266-.465,30.293-2.131,19.596-3.257,38.792.092,57.99,3.476,21.52,3.793,43.188,5.669,65.055,5.1,10.882-.283,20.893,4.374,31.503,5.748,15.584,2.019,30.652,6.922,46.318,8.475,5.144.509,10.338.495,15.507.765,1.413.074,3.223-.182,4.142.575,2.078,1.71,5.438,3.009,5.136,6.178-.3,3.163-3.478,3.777-6.149,4.17-9.019,1.326-18.085,2.146-27.217,1.992-6.76-.117-13.506-.003-20.187,1.98ZM538.106,51.056c-.02.436-.041.873-.061,1.309,10.391.387,20.786.931,31.073-1.309h-31.012Z",
    "M871.095,88.589c.43,6.476-2.298,13.545-4.16,20.781-1.1,4.279-7.152,5.825-6.162,11.238-.471.013-1.128.225-1.371-.003-.466-.437-1.103-1.252-.966-1.691,2.019-6.455-.734-10.79-6.212-13.698-4.87-2.585-9.879-5.164-15.653-4.473-1.857.222-3.031-.277-4.246-1.466-16.575-16.23-33.276-32.33-48.123-50.227-2.753-3.318-2.793-5.301.659-8.169,12.403-10.306,26.335-12.849,41.655-8.892,24.423,6.306,44.497,31.339,44.578,56.6Z",
    "M838.904,110.498c-.043-3.053,1.396-4.408,4.335-3.661,2.736.695,5.476,1.474,8.088,2.528,3.81,1.536,6.22,4.322,5.438,8.661-.756,4.194-3.966,6.152-7.839,6.896-4.185.804-5.966-2.148-7.547-5.296-1.459-2.903-2.094-6.003-2.474-9.129Z",
  ];

  function findBase(id) {
    for (var i = 0; i < BASES.length; i++)
      if (BASES[i].id === id) return BASES[i];
    return null;
  }

  function calc(model, dist, hasObs, obsH, obsD) {
    var m = MODELS[model];
    if (!m || !dist || dist <= 0) return null;
    if (dist < m.minDist)
      return { rec: null, tooClose: true, minDist: m.minDist, flex: m.flex };
    var si = dist * 12,
      th = m.height - m.droop,
      ta = th + 6,
      tf = m.flex,
      cp = si - 24,
      hr = cp - tf;
    if (hr <= 0) return { rec: CORDS[0], short: true };
    var ct;
    if (hasObs && obsH > 0 && obsD > 0) {
      var oa = obsH + 6,
        s1h = obsD - tf,
        s1v = ta - oa,
        s1 = Math.sqrt(s1h * s1h + s1v * s1v),
        s2h = cp - obsD,
        s2v = oa,
        s2 = Math.sqrt(s2h * s2h + s2v * s2v);
      ct = s1 + s2;
    } else ct = Math.sqrt(hr * hr + ta * ta);
    var cr = ct / WE,
      crf = cr / 12,
      rec = null;
    for (var i = 0; i < CORDS.length; i++)
      if (CORDS[i] >= crf) {
        rec = CORDS[i];
        break;
      }
    if (!rec) rec = CORDS[CORDS.length - 1];
    var floored = false;
    if (rec < POOL_MIN_CORD_FT) {
      /* Recommend the floor cord and describe where IT puts the swimmer, so
         every number shown matches the cord we recommend. */
      rec = POOL_MIN_CORD_FT;
      floored = true;
      cr = rec * 12;
      crf = rec;
      ct = cr * WE;
      hr = Math.sqrt(ct * ct - ta * ta);
    }
    /* Forward travel between floating at rest (pole straight, cord at rest
       length) and steady swimming (full flex + working elongation) —
       straight-line approximation on the obstruction path. */
    var rh = cr > ta ? Math.sqrt(cr * cr - ta * ta) : 0;
    return {
      tensioned: (ct / 12).toFixed(1),
      rest: crf.toFixed(1),
      travel: ((hr + tf - rh) / 12).toFixed(1),
      rec: rec,
      floored: floored,
      swimAt: ((hr + tf + 24) / 12).toFixed(1),
      long: crf > 20,
      short: false,
      tooClose: false,
    };
  }

  /* Reverse calc: given a cord length (ft) and model, what swim distance (ft) does it reach? */
  function cordToDist(model, cordLen) {
    var m = MODELS[model];
    if (!m || !cordLen) return 0;
    var crIn = cordLen * 12; /* rest length in inches */
    var ctIn = crIn * WE; /* tensioned length in inches */
    var ta = m.height - m.droop + 6;
    if (ctIn <= ta)
      return m.minDist; /* cord too short to reach past pole height */
    var hr = Math.sqrt(ctIn * ctIn - ta * ta);
    var cp = hr + m.flex;
    var si = cp + 24;
    return si / 12;
  }

  function Gate(p) {
    var s = useState("");
    var code = s[0],
      setCode = s[1];
    var e = useState(false);
    var err = e[0],
      setErr = e[1];
    function go() {
      if (code.trim().toLowerCase() === ACCESS_CODE.toLowerCase()) p.onOk();
      else {
        setErr(true);
        setTimeout(function () {
          setErr(false);
        }, 2000);
      }
    }
    return h(
      "div",
      {
        style: {
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: C.graphite,
          padding: 24,
        },
      },
      h(
        "div",
        {
          style: {
            background: C.white,
            borderRadius: 12,
            padding: "48px 40px",
            maxWidth: 400,
            width: "100%",
            textAlign: "center",
          },
        },
        h(
          "div",
          {
            style: {
              fontFamily: f,
              fontSize: 20,
              fontWeight: 700,
              color: C.graphite,
              marginBottom: 4,
              textTransform: "uppercase",
            },
          },
          "SWIM",
          h("span", { style: { color: C.blue } }, "TETHER"),
        ),
        h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 13,
              color: C.charcoal,
              marginBottom: 28,
              opacity: 0.6,
            },
          },
          "Kit Builder \u2014 Internal Testing",
        ),
        h("input", {
          type: "text",
          placeholder: "Enter access code",
          value: code,
          onChange: function (e) {
            setCode(e.target.value);
          },
          onKeyDown: function (e) {
            if (e.key === "Enter") go();
          },
          style: {
            width: "100%",
            padding: "13px 16px",
            fontFamily: bf,
            fontSize: 15,
            border: "2px solid " + (err ? C.red : C.charcoal),
            borderRadius: 6,
            outline: "none",
            marginBottom: 12,
            textAlign: "center",
            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
          },
        }),
        err
          ? h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.red,
                  marginBottom: 12,
                },
              },
              "Incorrect code.",
            )
          : null,
        h(
          "button",
          {
            onClick: go,
            style: {
              width: "100%",
              padding: "13px",
              fontFamily: f,
              fontSize: 13,
              fontWeight: 600,
              color: C.graphite,
              background: C.volt,
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
              textTransform: "uppercase",
            },
          },
          "Enter",
        ),
      ),
    );
  }

  function Steps(p) {
    var items = [];
    for (var i = 0; i < p.labels.length; i++) {
      (function (idx) {
        var canClick = idx <= p.cur;
        items.push(
          h(
            "div",
            {
              key: idx,
              style: {
                display: "flex",
                alignItems: "center",
                flex: idx < p.total - 1 ? 1 : "none",
              },
            },
            h(
              "div",
              {
                onClick: canClick
                  ? function () {
                      p.onJump(idx);
                    }
                  : undefined,
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: canClick ? "pointer" : "default",
                },
              },
              h(
                "div",
                {
                  style: {
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: f,
                    fontSize: 11,
                    fontWeight: 700,
                    background:
                      idx < p.cur ? C.blue : idx === p.cur ? C.volt : C.ad,
                    color: idx < p.cur ? C.white : C.graphite,
                    transition: "all .3s",
                    boxShadow:
                      idx === p.cur ? "0 0 0 3px rgba(206,255,0,.3)" : "none",
                    flexShrink: 0,
                  },
                },
                idx < p.cur ? "\u2713" : String(idx + 1),
              ),
              h(
                "span",
                {
                  style: {
                    fontFamily: f,
                    fontSize: 11,
                    fontWeight: 600,
                    color: idx <= p.cur ? C.graphite : C.charcoal,
                    letterSpacing: ".04em",
                    textTransform: "uppercase",
                    opacity: idx <= p.cur ? 1 : 0.5,
                    textDecoration:
                      canClick && idx < p.cur ? "underline" : "none",
                  },
                },
                p.labels[idx],
              ),
            ),
            idx < p.total - 1
              ? h("div", {
                  style: {
                    flex: 1,
                    height: 2,
                    background: idx < p.cur ? C.blue : C.ad,
                    margin: "0 10px",
                    borderRadius: 1,
                  },
                })
              : null,
          ),
        );
      })(i);
    }
    return h(
      "div",
      { style: { display: "flex", alignItems: "center", marginBottom: 18 } },
      items,
    );
  }

  function Card(p) {
    var s = p.sel;
    return h(
      "div",
      {
        onClick: p.onClick,
        style: {
          padding: 18,
          borderRadius: 10,
          cursor: "pointer",
          border: s ? "2px solid " + C.blue : "1.5px solid " + C.ad,
          background: s ? C.blue + "08" : C.white,
          transition: "all .2s",
          position: "relative",
          boxShadow: s ? "0 0 0 3px " + C.blue + "15" : "none",
        },
      },
      p.tag
        ? h(
            "div",
            {
              style: {
                position: "absolute",
                top: -1,
                right: 16,
                background: C.blue,
                color: C.white,
                fontFamily: f,
                fontSize: 9,
                fontWeight: 700,
                padding: "2px 8px",
                borderRadius: "0 0 4px 4px",
                textTransform: "uppercase",
              },
            },
            p.tag,
          )
        : null,
      h(
        "div",
        { style: { display: "flex", alignItems: "flex-start", gap: 12 } },
        h(
          "div",
          {
            style: {
              width: 20,
              height: 20,
              borderRadius: "50%",
              border: "2px solid " + (s ? C.blue : C.ad),
              background: s ? C.blue : "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              marginTop: 1,
              transition: "all .2s",
            },
          },
          s
            ? h("div", {
                style: {
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: C.white,
                },
              })
            : null,
        ),
        h("div", { style: { flex: 1 } }, p.children),
      ),
    );
  }

  function Btn(p) {
    var s = useState(false);
    var hv = s[0],
      setHv = s[1];
    return h(
      "button",
      {
        onClick: p.dis ? undefined : p.onClick,
        onMouseEnter: function () {
          setHv(true);
        },
        onMouseLeave: function () {
          setHv(false);
        },
        style: {
          fontFamily: f,
          fontSize: p.sm ? 12 : 13,
          fontWeight: 600,
          letterSpacing: ".06em",
          textTransform: "uppercase",
          padding: p.sm ? "10px 18px" : "13px 28px",
          borderRadius: 6,
          border: p.pri ? "none" : "1.5px solid " + C.ad,
          background: p.dis
            ? C.ad
            : p.pri
              ? hv
                ? C.blue
                : C.volt
              : hv
                ? C.arctic
                : C.white,
          color: p.dis ? C.charcoal : C.graphite,
          cursor: p.dis ? "not-allowed" : "pointer",
          transition: "all .2s",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        },
      },
      p.children,
    );
  }

  function PoleSVG(props) {
    var poleIn = props.height;
    var humanIn = 65;
    var maxIn = Math.max(humanIn, poleIn);
    var topPad = 12; /* px above tallest element for labels */
    var botPad = 4;
    var drawH = 80;
    var svgH = drawH + topPad + botPad;
    var svgW = 62;
    var scale = drawH / maxIn;
    var poleH = poleIn * scale;
    var humanH = humanIn * scale;
    var groundY = svgH - botPad;
    /* Human figure */
    var hx = 20;
    var headR = humanH * 0.06;
    if (headR < 3) headR = 3;
    var headCy = groundY - humanH + headR;
    var neckY = headCy + headR + 1;
    var shoulderY = neckY + 2;
    var shoulderW = 7;
    var elbowY = shoulderY + humanH * 0.16;
    var handY = elbowY + humanH * 0.12;
    var hipY = groundY - humanH * 0.4;
    var kneeY = groundY - humanH * 0.18;
    var footY = groundY;
    /* torso + legs path */
    var body =
      "M" +
      (hx - shoulderW) +
      "," +
      shoulderY +
      " Q" +
      hx +
      "," +
      (shoulderY - 1) +
      " " +
      (hx + shoulderW) +
      "," +
      shoulderY +
      " L" +
      (hx + 5) +
      "," +
      hipY +
      " L" +
      (hx + 6) +
      "," +
      kneeY +
      " L" +
      (hx + 7) +
      "," +
      footY +
      " L" +
      (hx + 4) +
      "," +
      footY +
      " L" +
      (hx + 2) +
      "," +
      kneeY +
      " L" +
      hx +
      "," +
      (hipY + 6) +
      " L" +
      (hx - 2) +
      "," +
      kneeY +
      " L" +
      (hx - 4) +
      "," +
      footY +
      " L" +
      (hx - 7) +
      "," +
      footY +
      " L" +
      (hx - 6) +
      "," +
      kneeY +
      " L" +
      (hx - 5) +
      "," +
      hipY +
      " Z";
    /* arms: shoulder down to sides */
    var armL =
      "M" +
      (hx - shoulderW) +
      "," +
      shoulderY +
      " L" +
      (hx - shoulderW - 2) +
      "," +
      elbowY +
      " L" +
      (hx - shoulderW - 1) +
      "," +
      handY;
    var armR =
      "M" +
      (hx + shoulderW) +
      "," +
      shoulderY +
      " L" +
      (hx + shoulderW + 2) +
      "," +
      elbowY +
      " L" +
      (hx + shoulderW + 1) +
      "," +
      handY;
    /* Pole */
    var px = 46;
    var poleTop = groundY - poleH;
    var poleBot = groundY;
    var fc = C.charcoal;
    return h(
      "svg",
      {
        width: svgW,
        height: svgH,
        viewBox: "0 0 " + svgW + " " + svgH,
        style: { flexShrink: 0 },
      },
      /* ground */
      h("line", {
        x1: 4,
        y1: groundY,
        x2: svgW - 4,
        y2: groundY,
        stroke: C.ad,
        strokeWidth: 1,
      }),
      /* human head */
      h("circle", { cx: hx, cy: headCy, r: headR, fill: fc, opacity: 0.28 }),
      /* neck */
      h("line", {
        x1: hx,
        y1: headCy + headR,
        x2: hx,
        y2: neckY,
        stroke: fc,
        strokeWidth: 2,
        opacity: 0.28,
      }),
      /* body */
      h("path", { d: body, fill: fc, opacity: 0.28 }),
      /* arms */
      h("path", {
        d: armL,
        fill: "none",
        stroke: fc,
        strokeWidth: 1.8,
        strokeLinecap: "round",
        opacity: 0.28,
      }),
      h("path", {
        d: armR,
        fill: "none",
        stroke: fc,
        strokeWidth: 1.8,
        strokeLinecap: "round",
        opacity: 0.28,
      }),
      /* human label */
      h(
        "text",
        {
          x: hx,
          y: groundY - humanH - 6,
          textAnchor: "middle",
          fontFamily: f,
          fontSize: "7",
          fontWeight: 600,
          fill: fc,
          opacity: 0.4,
        },
        "5'5\"",
      ),
      /* pole shaft */
      h("line", {
        x1: px,
        y1: poleTop,
        x2: px,
        y2: poleBot,
        stroke: C.blue,
        strokeWidth: 3.5,
        strokeLinecap: "round",
      }),
      /* base plate */
      h("rect", {
        x: px - 6,
        y: poleBot - 2,
        width: 12,
        height: 3,
        rx: 1,
        fill: fc,
        opacity: 0.3,
      }),
      /* pole tip */
      h("circle", { cx: px, cy: poleTop, r: 2.5, fill: C.blue }),
      /* pole label */
      h(
        "text",
        {
          x: px,
          y: poleTop - 5,
          textAnchor: "middle",
          fontFamily: f,
          fontSize: "7",
          fontWeight: 700,
          fill: C.blue,
        },
        Math.round(poleIn) + '"',
      ),
    );
  }

  function S0(p) {
    var opts = [
      {
        k: "pool",
        name: "Pool or open water",
        desc: "In-ground or above-ground pool, dock, or open water",
      },
      {
        k: "swim_spa",
        name: "Swim spa",
        desc: "A swim spa with a factory-installed tether base",
      },
    ];
    var cards = opts.map(function (o) {
      return h(
        Card,
        {
          key: o.k,
          sel: p.setting === o.k,
          onClick: function () {
            p.choose(o.k);
          },
        },
        h(
          "div",
          null,
          h(
            "p",
            {
              style: {
                fontFamily: f,
                fontSize: 15,
                fontWeight: 700,
                color: C.graphite,
                margin: "0 0 2px",
              },
            },
            o.name,
          ),
          h(
            "p",
            {
              style: {
                fontFamily: bf,
                fontSize: 13,
                color: C.charcoal,
                margin: 0,
                opacity: 0.7,
              },
            },
            o.desc,
          ),
        ),
      );
    });
    return h(
      "div",
      { style: { display: "flex", flexDirection: "column", gap: 10 } },
      cards,
    );
  }

  function S1(p) {
    var cards = MODEL_ORDER.map(function (key) {
      var m = MODELS[key];
      return h(
        Card,
        {
          key: key,
          sel: p.model === key,
          onClick: function () {
            p.set(key);
          },
          tag: m.pop ? "Most Popular" : null,
        },
        h(
          "div",
          { style: { display: "flex", alignItems: "center", gap: 14 } },
          h(PoleSVG, { height: m.height }),
          h(
            "div",
            { style: { flex: 1, minWidth: 0 } },
            h(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  marginBottom: 3,
                },
              },
              h(
                "p",
                {
                  style: {
                    fontFamily: f,
                    fontSize: 15,
                    fontWeight: 700,
                    color: C.graphite,
                    margin: 0,
                  },
                },
                m.name,
              ),
              h(
                "div",
                { style: { textAlign: "right", flexShrink: 0 } },
                h(
                  "span",
                  {
                    style: {
                      fontFamily: f,
                      fontSize: 20,
                      fontWeight: 700,
                      color: C.graphite,
                    },
                  },
                  "$" + polePrice(key),
                ),
              ),
            ),
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 13,
                  color: C.charcoal,
                  margin: "0 0 6px",
                  lineHeight: 1.4,
                },
              },
              m.desc,
            ),
            h(
              "div",
              { style: { display: "flex", gap: 12, flexWrap: "wrap" } },
              h(
                "span",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 11,
                    color: C.charcoal,
                    opacity: 0.6,
                  },
                },
                "Height: " + m.height + '"',
              ),
              h(
                "span",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 11,
                    color: C.charcoal,
                    opacity: 0.6,
                  },
                },
                "Flex: " + m.flex + '"',
              ),
              h(
                "span",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 11,
                    color: C.charcoal,
                    opacity: 0.6,
                  },
                },
                "Best for: " + m.best,
              ),
            ),
          ),
        ),
      );
    });
    return h(
      "div",
      null,
      h(
        "div",
        { style: { display: "flex", flexDirection: "column", gap: 10 } },
        cards,
      ),
    );
  }

  function S2(p) {
    /* Fork-specific base & fitting. p.setting === 'swim_spa' | 'pool'. */
    var isSwim = p.setting === "swim_spa";
    var opts = isSwim
      ? [
          {
            id: "arctic_adapter",
            base: "arctic",
            fit: "standard",
            name: "Arctic Adapter",
            desc: "For swim spas built by Arctic Spas \u2014 threads into the factory receiver",
          },
          {
            id: "std",
            base: "have_base",
            fit: "standard",
            name: "Standard fitting",
            desc: "Your factory base has a Swim Tether logo, or a nickel drops flat into the hole (7/8\u2033 or larger)",
          },
          {
            id: "nar",
            base: "have_base",
            fit: "narrow",
            name: "Narrow fitting",
            desc: "A nickel won\u2019t go into the hole (smaller than 7/8\u2033) \u2014 we\u2019ll make your pole to match, no charge",
          },
          {
            id: "fit_unsure",
            base: "have_base",
            fit: "unsure",
            name: "I\u2019m not sure",
            desc: "Grab a coin and know in ten seconds \u2014 we\u2019ll show you how",
          },
        ]
      : [
          {
            id: "concrete",
            base: "concrete",
            fit: "standard",
            name: "Concrete Deck Base",
            desc: "Drill-in anchor for concrete, stone, or paver decks \u00b7 includes rubber plug \u00b7 sets with hydraulic cement (not included)",
          },
          {
            id: "threaded",
            base: "threaded",
            fit: "standard",
            name: "Threaded Wood Deck Base",
            desc: "Threaded mount for wood or composite decking \u00b7 includes rubber plug",
          },
          {
            id: "uha_cs",
            base: "uha_cs",
            fit: "standard",
            name: "Screw-In Umbrella Hole Adapter",
            desc: "For composite umbrella sleeves (molded plastic — black, white, or tan) \u00b7 no drilling \u2014 screws right into the sleeve you already have \u00b7 base included",
          },
          {
            id: "uha_bz",
            base: "uha_bz",
            fit: "standard",
            name: "Drop-In Umbrella Hole Adapter",
            desc: "For cast bronze umbrella sleeves (solid metal, 2\u2033 bore) \u00b7 no drilling \u2014 drops in and lifts back out \u00b7 base included",
          },
          {
            id: "have_base",
            base: "have_base",
            fit: null,
            name: "I already have a base installed",
            desc: "Use your existing deck base \u2014 just the pole, cord, and belt",
          },
        ];
    /* Same rule as the BASES cards: options for pulled products don't render. */
    opts = opts.filter(function (o) {
      return o.base === "have_base" || baseIsLive(o.base);
    });
    function isActive(o) {
      if (o.base !== "have_base") return p.base === o.base;
      if (isSwim) return p.base === "have_base" && p.fit === o.fit;
      return p.base === "have_base";
    }
    function priceLabel(o) {
      if (o.base === "have_base") return "Same Price";
      if (o.base === "concrete") return "Included";
      return "+$" + basePrice(o.base).toFixed(2);
    }
    var cards = opts.map(function (o) {
      return h(
        Card,
        {
          key: o.id,
          sel: isActive(o),
          onClick: function () {
            p.set(o.base);
            p.setFit(o.fit || "");
          },
        },
        h(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 8,
            },
          },
          h(
            "div",
            null,
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 14,
                  fontWeight: 600,
                  color: C.graphite,
                  margin: "0 0 2px",
                },
              },
              o.name,
            ),
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.charcoal,
                  margin: 0,
                  opacity: 0.7,
                },
              },
              o.desc,
            ),
          ),
          h(
            "span",
            {
              style: {
                fontFamily: f,
                fontSize: 13,
                fontWeight: 700,
                color:
                  o.base === "threaded" || o.base === "arctic"
                    ? C.graphite
                    : C.green,
              },
            },
            priceLabel(o),
          ),
        ),
      );
    });
    var helper = isSwim
      ? h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 12,
              color: C.charcoal,
              opacity: 0.7,
              margin: "12px 2px 0",
            },
          },
          "Not sure which base you have? ",
          h(
            "a",
            {
              href: "/pages/contact",
              style: {
                color: C.blue,
                fontWeight: 600,
                textDecoration: "underline",
              },
            },
            "Send us a photo",
          ),
          " and we\u2019ll confirm.",
        )
      : null;
    var fitQ = null;
    if (!isSwim && p.base === "have_base") {
      var fopts = [
        {
          k: "standard",
          l: "7/8\u2033 or larger",
          d: "Standard Swim Tether fitting (0.87\u2033)",
        },
        {
          k: "narrow",
          l: "Smaller than 7/8\u2033",
          d: "We\u2019ll make your pole with a narrower fitting \u2014 no extra charge",
        },
        { k: "unsure", l: "I\u2019m not sure", d: "" },
      ];
      var fitBtns = fopts.map(function (o) {
        var sel = p.fit === o.k;
        return h(
          "div",
          {
            key: o.k,
            onClick: function () {
              p.setFit(o.k);
            },
            style: {
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              padding: "12px 14px",
              borderRadius: 8,
              cursor: "pointer",
              border: sel ? "2px solid " + C.blue : "1.5px solid " + C.ad,
              background: sel ? C.blue + "08" : C.white,
              transition: "all .2s",
            },
          },
          h(
            "div",
            {
              style: {
                width: 18,
                height: 18,
                borderRadius: "50%",
                border: "2px solid " + (sel ? C.blue : C.ad),
                background: sel ? C.blue : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                marginTop: 1,
                transition: "all .2s",
              },
            },
            sel
              ? h("div", {
                  style: {
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: C.white,
                  },
                })
              : null,
          ),
          h(
            "div",
            null,
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 13,
                  fontWeight: 600,
                  color: C.graphite,
                  margin: 0,
                },
              },
              o.l,
            ),
            o.d
              ? h(
                  "p",
                  {
                    style: {
                      fontFamily: bf,
                      fontSize: 11,
                      color: C.charcoal,
                      margin: "2px 0 0",
                      opacity: 0.7,
                    },
                  },
                  o.d,
                )
              : null,
          ),
        );
      });
      fitQ = h(
        "div",
        {
          style: {
            marginTop: 14,
            padding: "18px",
            background: C.arctic,
            border: "1px solid " + C.ad,
            borderRadius: 10,
          },
        },
        h(
          "p",
          {
            style: {
              fontFamily: f,
              fontSize: 13,
              fontWeight: 600,
              color: C.graphite,
              margin: "0 0 4px",
            },
          },
          "What\u2019s the inside diameter of the hole in your base plate?",
        ),
        h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 12,
              color: C.charcoal,
              margin: "0 0 12px",
              opacity: 0.7,
            },
          },
          "Measure across the opening where the pole inserts — or drop a nickel in: falls flat to the bottom means 7/8″ or larger; won’t go in means smaller.",
        ),
        h(
          "div",
          { style: { display: "flex", flexDirection: "column", gap: 6 } },
          fitBtns,
        ),
        p.fit === "unsure"
          ? h(
              "div",
              {
                style: {
                  marginTop: 10,
                  padding: "12px 14px",
                  background: C.blue + "08",
                  border: "1px solid " + C.blue + "25",
                  borderRadius: 8,
                },
              },
              h(
                "p",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 12,
                    color: C.graphite,
                    margin: 0,
                    lineHeight: 1.6,
                  },
                },
                "The ",
                h(
                  "a",
                  {
                    href: "/pages/base-fit-guide",
                    target: "_blank",
                    rel: "noopener",
                    style: {
                      color: C.blue,
                      fontWeight: 600,
                      textDecoration: "none",
                    },
                  },
                  "Base Fit Guide",
                ),
                " coin test answers it in ten seconds \u2014 or ",
                h(
                  "a",
                  {
                    href: "/pages/contact",
                    style: {
                      color: C.blue,
                      fontWeight: 600,
                      textDecoration: "none",
                    },
                  },
                  "send us a photo",
                ),
                " of your base plate and we\u2019ll let you know which fitting you need.",
              ),
            )
          : null,
      );
    }
    var unsurePanel =
      isSwim && p.base === "have_base" && p.fit === "unsure"
        ? h(
            "div",
            {
              style: {
                marginTop: 10,
                padding: "12px 14px",
                background: C.blue + "08",
                border: "1px solid " + C.blue + "25",
                borderRadius: 8,
              },
            },
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.graphite,
                  margin: 0,
                  lineHeight: 1.6,
                },
              },
              "The ",
              h(
                "a",
                {
                  href: "/pages/base-fit-guide",
                  target: "_blank",
                  rel: "noopener",
                  style: {
                    color: C.blue,
                    fontWeight: 600,
                    textDecoration: "none",
                  },
                },
                "Base Fit Guide",
              ),
              " coin test answers it in ten seconds — or ",
              h(
                "a",
                {
                  href: "/pages/contact",
                  style: {
                    color: C.blue,
                    fontWeight: 600,
                    textDecoration: "none",
                  },
                },
                "send us a photo",
              ),
              " of your base and we’ll confirm which fitting you need.",
            ),
          )
        : null;
    return h(
      "div",
      null,
      h(
        "div",
        { style: { display: "flex", flexDirection: "column", gap: 8 } },
        cards,
      ),
      unsurePanel,
      helper,
      fitQ,
    );
  }

  function CordDiagram(props) {
    var m = MODELS[props.model];
    if (!m) return null;
    var dist = parseFloat(props.dist) || 0;
    var cord = props.cord;
    /* props.setback carries the base->water distance (one of the two metrics). */
    var waterDist =
      props.setback !== "" && props.setback != null
        ? parseFloat(props.setback) || 0
        : 0;
    if (!dist && cord) {
      var cd0 = cordToDist(props.model, cord);
      dist =
        cd0 > 0 ? Math.round(cd0 * 10) / 10 : Math.round(cord * 1.1 * 10) / 10;
    }
    if (!dist && !cord) return null;
    var svgW = 480,
      svgH = 262,
      deckY = 205,
      waterY = deckY + 12,
      baseX = 55;
    var distIn = dist * 12;
    if (distIn < 48) distIn = 48;
    var waterIn = waterDist * 12;
    var sceneExtent = Math.max(distIn, waterIn) + 50;
    var availW = svgW - baseX - 40;
    var pxPerIn = availW / Math.max(sceneExtent, 72);
    var maxPPI = (deckY - 25) / m.height;
    if (pxPerIn > maxPPI) pxPerIn = maxPPI;
    var tipH = m.height - m.droop;
    var tipY = deckY - tipH * pxPerIn;
    if (tipY < 18) tipY = 18;
    var tipScaleY = deckY - tipY;
    var tipX = baseX + m.flex * pxPerIn;
    var poleH = m.height * pxPerIn;
    if (poleH > deckY - 15) poleH = deckY - 15;
    var cp1x = baseX + m.flex * pxPerIn * 0.05,
      cp1y = deckY - poleH * 0.55;
    var cp2x = baseX + m.flex * pxPerIn * 0.55,
      cp2y = tipY + tipScaleY * 0.05;
    var polePath =
      "M" +
      baseX +
      "," +
      deckY +
      " C" +
      cp1x +
      "," +
      cp1y +
      " " +
      cp2x +
      "," +
      cp2y +
      " " +
      tipX +
      "," +
      tipY;
    var swimCenterX = baseX + distIn * pxPerIn;
    var swimY = waterY + 2;
    var waterEdgeX = waterDist > 0 ? baseX + waterIn * pxPerIn : baseX;
    var bodyPx = 65 * pxPerIn;
    var feetX = swimCenterX - bodyPx * 0.55;
    if (feetX < baseX + 15) {
      bodyPx = (swimCenterX - baseX - 15) / 0.55;
    }
    if (bodyPx < 20) bodyPx = 20;
    var backX = swimCenterX,
      backY = swimY;
    var cordColor = cord ? C.blue : C.charcoal;
    var cordOp = cord ? 0.8 : 0.3;
    var staticFrac = cord ? 1 / (1 + CORD_STRETCH) : 1;
    var splitX = tipX + (backX - tipX) * staticFrac,
      splitY = tipY + (backY - tipY) * staticFrac;
    var stretchFt = cord ? Math.round(cord * CORD_STRETCH * 10) / 10 : 0;
    var staticMidX = (tipX + splitX) / 2,
      staticMidY = (tipY + splitY) / 2;
    var stretchMidX = (splitX + backX) / 2,
      stretchMidY = (splitY + backY) / 2;
    var waveStart = Math.round(waterEdgeX);
    var waveD = "";
    for (var wx = waveStart; wx < svgW; wx += 20) {
      waveD +=
        (wx === waveStart ? "M" : "L") +
        wx +
        "," +
        (waterY + Math.sin(wx * 0.08) * 1.5);
    }
    var sScale = bodyPx / SWIMMER_VB.w;
    var sTx = backX - SWIMMER_VB.cx * sScale,
      sTy = swimY - SWIMMER_VB.cy * sScale;
    var sTransform = "translate(" + sTx + "," + sTy + ") scale(" + sScale + ")";
    var so = 0.4,
      dimY = deckY + 22,
      dim2Y = dimY + 18;
    var hasWater = waterDist > 0;
    return h(
      "svg",
      {
        width: "100%",
        height: svgH,
        viewBox: "0 0 " + svgW + " " + svgH,
        style: { display: "block", marginBottom: 14, overflow: "visible" },
      },
      h("rect", {
        x: waterEdgeX,
        y: waterY - 2,
        width: svgW - waterEdgeX,
        height: svgH - waterY + 4,
        fill: "#E8F4FD",
        opacity: 0.5,
      }),
      h("path", {
        d: waveD,
        fill: "none",
        stroke: C.blue,
        strokeWidth: 1,
        opacity: 0.25,
      }),
      h("line", {
        x1: 0,
        y1: deckY,
        x2: waterEdgeX,
        y2: deckY,
        stroke: C.charcoal,
        strokeWidth: 2,
        opacity: 0.3,
      }),
      h("rect", {
        x: 0,
        y: deckY,
        width: waterEdgeX,
        height: 8,
        fill: C.charcoal,
        opacity: 0.08,
      }),
      h(
        "text",
        {
          x: 8,
          y: deckY - 4,
          fontFamily: bf,
          fontSize: "8",
          fill: C.charcoal,
          opacity: 0.4,
        },
        "Deck",
      ),
      h(
        "text",
        {
          x: Math.min(waterEdgeX + 6, svgW - 42),
          y: waterY + 12,
          fontFamily: bf,
          fontSize: "8",
          fill: C.blue,
          opacity: 0.4,
        },
        "Water",
      ),
      hasWater
        ? h("line", {
            x1: waterEdgeX,
            y1: deckY - 6,
            x2: waterEdgeX,
            y2: waterY + 30,
            stroke: C.charcoal,
            strokeWidth: 1,
            strokeDasharray: "3,2",
            opacity: 0.25,
          })
        : null,
      h("rect", {
        x: baseX - 7,
        y: deckY - 3,
        width: 14,
        height: 4,
        rx: 1,
        fill: C.charcoal,
        opacity: 0.4,
      }),
      h("path", {
        d: polePath,
        fill: "none",
        stroke: C.graphite,
        strokeWidth: 2.5,
        strokeLinecap: "round",
      }),
      h("circle", { cx: tipX, cy: tipY, r: 3, fill: C.blue }),
      h(
        "text",
        {
          x: baseX - 6,
          y: deckY - tipScaleY * 0.5,
          fontFamily: f,
          fontSize: "8",
          fontWeight: 600,
          fill: C.charcoal,
          textAnchor: "end",
          opacity: 0.5,
        },
        m.name,
      ),
      dist > 0
        ? h("line", {
            x1: tipX,
            y1: tipY,
            x2: cord ? splitX : backX,
            y2: cord ? splitY : backY,
            stroke: cordColor,
            strokeWidth: 2,
            strokeDasharray: cord ? "none" : "4,3",
            opacity: cordOp,
          })
        : null,
      cord && dist > 0
        ? h("line", {
            x1: splitX,
            y1: splitY,
            x2: backX,
            y2: backY,
            stroke: cordColor,
            strokeWidth: 2,
            strokeDasharray: "5,3",
            opacity: cordOp * 0.7,
          })
        : null,
      cord && dist > 0
        ? h("circle", {
            cx: splitX,
            cy: splitY,
            r: 2,
            fill: cordColor,
            opacity: 0.5,
          })
        : null,
      cord && dist > 0
        ? h(
            "text",
            {
              x: staticMidX,
              y: staticMidY - 7,
              fontFamily: f,
              fontSize: "9",
              fontWeight: 700,
              fill: C.blue,
              textAnchor: "middle",
            },
            cord + "ft",
          )
        : null,
      cord && dist > 0 && stretchFt > 0
        ? h(
            "text",
            {
              x: stretchMidX,
              y: Math.min(stretchMidY, splitY) - 10,
              fontFamily: f,
              fontSize: "8",
              fontWeight: 600,
              fill: C.blue,
              textAnchor: "middle",
              opacity: 0.6,
            },
            "+" + stretchFt + "ft stretch",
          )
        : null,
      dist > 0
        ? h("circle", {
            cx: backX,
            cy: backY,
            r: 2.5,
            fill: C.blue,
            opacity: 0.8,
          })
        : null,
      dist > 0
        ? h(
            "g",
            { transform: sTransform, opacity: so },
            SWIMMER_PATHS.map(function (d, i) {
              return h("path", { key: i, d: d, fill: C.charcoal });
            }),
          )
        : null,
      dist > 0
        ? h(
            "text",
            {
              x: swimCenterX + 2,
              y: waterY + 26,
              fontFamily: bf,
              fontSize: "8",
              fill: C.charcoal,
              textAnchor: "middle",
              opacity: 0.4,
            },
            "Swim zone",
          )
        : null,
      hasWater
        ? h("line", {
            x1: baseX,
            y1: dimY,
            x2: waterEdgeX,
            y2: dimY,
            stroke: C.charcoal,
            strokeWidth: 0.5,
            opacity: 0.3,
          })
        : null,
      hasWater
        ? h("line", {
            x1: baseX,
            y1: dimY - 4,
            x2: baseX,
            y2: dimY + 4,
            stroke: C.charcoal,
            strokeWidth: 0.5,
            opacity: 0.3,
          })
        : null,
      hasWater
        ? h("line", {
            x1: waterEdgeX,
            y1: dimY - 4,
            x2: waterEdgeX,
            y2: dimY + 4,
            stroke: C.charcoal,
            strokeWidth: 0.5,
            opacity: 0.3,
          })
        : null,
      hasWater
        ? h(
            "text",
            {
              x: (baseX + waterEdgeX) / 2,
              y: dimY + 10,
              fontFamily: f,
              fontSize: "8",
              fontWeight: 600,
              fill: C.charcoal,
              textAnchor: "middle",
              opacity: 0.45,
            },
            waterDist < 1
              ? Math.round(waterDist * 12) + "″ to water"
              : waterDist + "ft to water",
          )
        : null,
      dist > 0
        ? h("line", {
            x1: baseX,
            y1: dim2Y,
            x2: swimCenterX,
            y2: dim2Y,
            stroke: C.blue,
            strokeWidth: 0.5,
            opacity: 0.4,
          })
        : null,
      dist > 0
        ? h("line", {
            x1: baseX,
            y1: dim2Y - 4,
            x2: baseX,
            y2: dim2Y + 4,
            stroke: C.blue,
            strokeWidth: 0.5,
            opacity: 0.4,
          })
        : null,
      dist > 0
        ? h("line", {
            x1: swimCenterX,
            y1: dim2Y - 4,
            x2: swimCenterX,
            y2: dim2Y + 4,
            stroke: C.blue,
            strokeWidth: 0.5,
            opacity: 0.4,
          })
        : null,
      dist > 0
        ? h(
            "text",
            {
              x: (baseX + swimCenterX) / 2,
              y: dim2Y + 10,
              fontFamily: f,
              fontSize: "8",
              fontWeight: 600,
              fill: C.blue,
              textAnchor: "middle",
              opacity: 0.55,
            },
            Math.round(dist * 10) / 10 + "ft to swim center",
          )
        : null,
    );
  }

  function S3(p) {
    var result =
      p.model && p.sd ? calc(p.model, parseFloat(p.sd), false, 0, 0) : null;
    var togBtns = [
      { k: true, l: "Help me choose" },
      { k: false, l: "I know what I need" },
    ].map(function (t) {
      return h(
        "button",
        {
          key: String(t.k),
          onClick: function () {
            p.setUC(t.k);
          },
          style: {
            fontFamily: f,
            fontSize: 11,
            fontWeight: 600,
            padding: "8px 18px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            textTransform: "uppercase",
            background: p.uc === t.k ? C.graphite : C.ad,
            color: p.uc === t.k ? C.white : C.charcoal,
          },
        },
        t.l,
      );
    });
    var mData = MODELS[p.model];
    /* Auto-select recommended cord when distance changes (unless user manually picked) */
    var prevSdRef = useRef(p.sd);
    if (p.sd !== prevSdRef.current) {
      prevSdRef.current = p.sd;
      if (
        !p.manualCord &&
        result &&
        !result.tooClose &&
        !result.short &&
        !result.long &&
        result.rec
      ) {
        /* Schedule cord update — can't setState during render, so use microtask */
        var recCord = result.rec;
        Promise.resolve().then(function () {
          p.setCord(recCord);
        });
      }
    }
    /* Pool dimension change handler: update distance + auto-select cord */
    function handlePoolChange(newPoolLen, newSetback) {
      var pl = parseFloat(newPoolLen) || 0;
      var sb = parseFloat(newSetback) || 0;
      if (pl > 0 && sb > 0) {
        var autoDist = sb + pl / 2;
        p.setSD(String(Math.round(autoDist * 10) / 10));
        p.setAutoCalc(true);
        p.setManualCord(false);
      }
    }
    function handleDistManual(val) {
      p.setSD(val);
      p.setAutoCalc(false);
      p.setManualCord(false);
    }
    function handleAutoReset() {
      var pl = parseFloat(p.poolLen) || 0;
      var sb = parseFloat(p.setback) || 0;
      if (pl > 0 && sb > 0) {
        var autoDist = sb + pl / 2;
        p.setSD(String(Math.round(autoDist * 10) / 10));
        p.setAutoCalc(true);
        p.setManualCord(false);
      }
    }
    function handleCordButton(len) {
      p.setCord(len);
      p.setManualCord(true);
    }
    /* Model compatibility check */
    var dist = parseFloat(p.sd) || 0;
    var incompatible = dist > 0 && mData && dist < mData.minDist;
    var compatibleModels = [];
    if (incompatible) {
      MODEL_ORDER.forEach(function (key) {
        if (key !== p.model && MODELS[key].minDist <= dist)
          compatibleModels.push(key);
      });
    }
    var cordBtns = CORDS.map(function (len) {
      var isR =
          result &&
          !result.short &&
          !result.long &&
          !result.tooClose &&
          result.rec === len,
        sel = p.cord === len;
      /* Every pill shows the exact price delta — "+$0" on included lengths,
       "+$X" on upcharged ones — so shoppers see upfront what they'll pay.
       All 9 lengths are always selectable regardless of model — owner's call:
       calc gives a recommendation, but customer makes the final pick. */
      var cordP = cordPriceFromShopify(len);
      var isFree = cordP <= 0;
      var priceLabel = isFree
        ? "+$0"
        : "+$" + (cordP % 1 === 0 ? cordP.toFixed(0) : cordP.toFixed(2));
      var label = (len === 4.5 ? "4.5" : len) + "ft";
      var lenColor = sel ? C.blue : C.graphite;
      var priceColor = isFree
        ? sel
          ? C.blue
          : C.green
        : sel
          ? C.blue
          : C.charcoal;
      var priceOpacity = sel ? 0.85 : isFree ? 0.75 : 0.55;
      return h(
        "button",
        {
          key: len,
          onClick: function () {
            handleCordButton(len);
          },
          style: {
            fontFamily: f,
            fontSize: 12,
            fontWeight: sel ? 700 : 500,
            padding: "5px 14px 4px",
            borderRadius: 6,
            border: sel
              ? "2px solid " + C.blue
              : isR
                ? "2px solid " + C.blue + "50"
                : "1.5px solid " + C.ad,
            background: sel ? C.blue + "10" : C.white,
            color: lenColor,
            cursor: "pointer",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1.1,
            gap: 1,
            minWidth: 56,
          },
        },
        h("span", null, label),
        h(
          "span",
          {
            style: {
              fontFamily: f,
              fontSize: 9,
              fontWeight: 600,
              color: priceColor,
              opacity: priceOpacity,
              marginTop: 2,
              letterSpacing: 0.2,
            },
          },
          priceLabel,
        ),
        isR && !sel
          ? h("span", {
              style: {
                position: "absolute",
                top: -4,
                right: -3,
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: C.blue,
              },
            })
          : null,
      );
    });
    var calcUI = null;
    if (p.uc) {
      var waterSection = h(
        "div",
        { style: { marginBottom: 8 } },
        h(
          "label",
          {
            style: {
              fontFamily: bf,
              fontSize: 13,
              color: C.charcoal,
              display: "block",
              marginBottom: 4,
            },
          },
          "Distance from base to water",
        ),
        h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 11,
              color: C.charcoal,
              opacity: 0.6,
              margin: "0 0 8px",
            },
          },
          "How far your base sits back from the water's edge — the deck gap.",
        ),
        h(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
              marginBottom: 10,
              fontFamily: bf,
              fontSize: 13,
              color: C.charcoal,
            },
          },
          h("input", {
            type: "checkbox",
            checked: p.wStd,
            onChange: function (e) {
              p.setWater(p.wFt, p.wIn, e.target.checked);
            },
            style: {
              width: 16,
              height: 16,
              accentColor: C.blue,
              cursor: "pointer",
            },
          }),
          h("span", null, "Standard distance (6 in)"),
        ),
        h(
          "div",
          {
            style: {
              display: "flex",
              gap: 10,
              alignItems: "flex-end",
              opacity: p.wStd ? 0.45 : 1,
            },
          },
          h(
            "div",
            null,
            h(
              "label",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 11,
                  color: C.charcoal,
                  display: "block",
                  marginBottom: 3,
                  opacity: 0.65,
                },
              },
              "Feet",
            ),
            h("input", {
              type: "number",
              min: 0,
              max: 50,
              step: 1,
              value: p.wFt,
              disabled: p.wStd,
              onChange: function (e) {
                p.setWater(e.target.value, p.wIn, false);
              },
              placeholder: "0",
              style: {
                width: 80,
                padding: "9px 12px",
                fontFamily: bf,
                fontSize: 15,
                border: "2px solid " + C.charcoal,
                borderRadius: 6,
                outline: "none",
                background: C.white,
              },
            }),
          ),
          h(
            "div",
            null,
            h(
              "label",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 11,
                  color: C.charcoal,
                  display: "block",
                  marginBottom: 3,
                  opacity: 0.65,
                },
              },
              "Inches",
            ),
            h("input", {
              type: "number",
              min: 0,
              max: 11,
              step: 1,
              value: p.wIn,
              disabled: p.wStd,
              onChange: function (e) {
                p.setWater(p.wFt, e.target.value, false);
              },
              placeholder: "6",
              style: {
                width: 80,
                padding: "9px 12px",
                fontFamily: bf,
                fontSize: 15,
                border: "2px solid " + C.charcoal,
                borderRadius: 6,
                outline: "none",
                background: C.white,
              },
            }),
          ),
        ),
      );
      /* Distance input */
      var distSection = h(
        "div",
        { style: { marginBottom: 14 } },
        h(
          "label",
          {
            style: {
              fontFamily: bf,
              fontSize: 13,
              color: C.charcoal,
              display: "block",
              marginBottom: 4,
            },
          },
          "Distance from base to center of swim zone (feet)",
        ),
        h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 11,
              color: C.charcoal,
              opacity: 0.6,
              margin: "0 0 6px",
            },
          },
          "Measure from where your base is installed — or where you plan to install one — to the center of where you'll swim. Minimum " +
            mData.minDist +
            "ft for the " +
            p.model +
            ".",
        ),
        h(
          "div",
          { style: { display: "flex", alignItems: "center", gap: 8 } },
          h("input", {
            type: "number",
            min: mData.minDist,
            max: 30,
            step: 0.5,
            value: p.sd,
            onChange: function (e) {
              handleDistManual(e.target.value);
            },
            placeholder: "e.g. " + mData.minDist,
            style: {
              width: 120,
              padding: "9px 12px",
              fontFamily: bf,
              fontSize: 15,
              border: "2px solid " + C.charcoal,
              borderRadius: 6,
              outline: "none",
              background: C.white,
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
            },
          }),
        ),
      );
      /* Compatibility warning with model swap buttons */
      var compatBox = null;
      if (incompatible) {
        var swapBtns = compatibleModels.map(function (key) {
          var cm = MODELS[key];
          return h(
            "button",
            {
              key: key,
              onClick: function () {
                p.onModelSwap(key);
              },
              style: {
                fontFamily: f,
                fontSize: 12,
                fontWeight: 600,
                padding: "10px 20px",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
                background: C.blue,
                color: C.white,
                textTransform: "uppercase",
              },
            },
            cm.name,
          );
        });
        compatBox = h(
          "div",
          {
            style: {
              padding: "16px 18px",
              borderRadius: 10,
              marginBottom: 14,
              background: C.red + "08",
              border: "1px solid " + C.red + "30",
            },
          },
          h(
            "p",
            {
              style: {
                fontFamily: f,
                fontSize: 13,
                fontWeight: 600,
                color: C.red,
                margin: "0 0 4px",
              },
            },
            "Setup too close for the " + p.model,
          ),
          h(
            "p",
            {
              style: {
                fontFamily: bf,
                fontSize: 12,
                color: C.charcoal,
                margin: "0 0 12px",
                lineHeight: 1.5,
              },
            },
            "The " +
              p.model +
              " needs at least " +
              mData.minDist +
              "ft of swim distance. Your setup calculates to " +
              dist +
              "ft." +
              (compatibleModels.length > 0
                ? " These models work with your pool:"
                : ""),
          ),
          compatibleModels.length > 0
            ? h(
                "div",
                { style: { display: "flex", gap: 8, flexWrap: "wrap" } },
                swapBtns,
              )
            : h(
                "p",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 12,
                    color: C.charcoal,
                    margin: 0,
                  },
                },
                "Try increasing your swim distance or base setback.",
              ),
        );
      }
      /* Result box */
      var resBox = null;
      if (result && !incompatible) {
        var isE = result.long || result.short || result.tooClose;
        var inner;
        if (result.tooClose)
          inner = h(
            "div",
            null,
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 13,
                  fontWeight: 600,
                  color: C.red,
                  margin: "0 0 4px",
                },
              },
              "Too close for comfortable swimming",
            ),
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.charcoal,
                  margin: 0,
                  lineHeight: 1.5,
                },
              },
              "With the " +
                p.model +
                "\u2019s " +
                result.flex +
                "\u2033 forward flex, you need at least " +
                result.minDist +
                "ft from the base to have enough room to kick and stroke comfortably. Try increasing the distance or choosing a shorter model.",
            ),
          );
        else if (result.short)
          inner = h(
            "div",
            null,
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 13,
                  fontWeight: 600,
                  color: C.red,
                  margin: "0 0 4px",
                },
              },
              "Swim distance too short",
            ),
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.charcoal,
                  margin: 0,
                },
              },
              "Try increasing distance or a shorter model.",
            ),
          );
        else if (result.long)
          inner = h(
            "div",
            null,
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 13,
                  fontWeight: 600,
                  color: C.red,
                  margin: "0 0 4px",
                },
              },
              "Swim distance too far",
            ),
            h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.charcoal,
                  margin: 0,
                },
              },
              "Calculated cord (" + result.rest + "ft) exceeds max 20ft.",
            ),
          );
        else
          inner = h(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 12,
              },
            },
            h(
              "div",
              null,
              h(
                "p",
                {
                  style: {
                    fontFamily: f,
                    fontSize: 13,
                    fontWeight: 600,
                    color: C.graphite,
                    margin: "0 0 3px",
                  },
                },
                "Recommended: ",
                h("span", { style: { color: C.blue } }, result.rec + "ft cord"),
              ),
              result.floored
                ? h(
                    "p",
                    {
                      style: {
                        fontFamily: bf,
                        fontSize: 12,
                        color: C.charcoal,
                        margin: "0 0 4px",
                      },
                    },
                    "8 ft is our shortest cord for a pool, so you don't drift back onto the wall or steps. It puts your swim zone about " +
                      result.swimAt +
                      "ft from the base.",
                  )
                : null,
              h(
                "p",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 11,
                    color: C.charcoal,
                    opacity: 0.7,
                    margin: 0,
                  },
                },
                "Rest: " +
                  result.rest +
                  "ft \u00B7 Stretched: " +
                  result.tensioned +
                  "ft",
              ),
              h(
                "p",
                {
                  style: {
                    fontFamily: bf,
                    fontSize: 11,
                    color: C.charcoal,
                    opacity: 0.7,
                    margin: "2px 0 0",
                  },
                },
                "Travel: ~" +
                  result.travel +
                  "ft forward from rest to steady swimming",
              ),
            ),
            !p.manualCord || p.cord === result.rec
              ? null
              : h(
                  Btn,
                  {
                    sm: true,
                    pri: true,
                    onClick: function () {
                      p.setCord(result.rec);
                      p.setManualCord(false);
                    },
                  },
                  "Select " + result.rec + "ft",
                ),
          );
        resBox = h(
          "div",
          {
            style: {
              padding: "18px 20px",
              borderRadius: 10,
              marginBottom: 18,
              background: isE ? C.red + "08" : C.green + "08",
              border: "1px solid " + (isE ? C.red + "30" : C.green + "30"),
            },
          },
          inner,
        );
      }
      calcUI = h(
        "div",
        null,
        h(
          "div",
          {
            style: {
              background: C.arctic,
              borderRadius: 10,
              padding: 20,
              marginBottom: 18,
              border: "1px solid " + C.ad,
            },
          },
          h(
            "p",
            {
              style: {
                fontFamily: f,
                fontSize: 12,
                fontWeight: 600,
                color: C.graphite,
                margin: "0 0 14px",
              },
            },
            "Cord Length Calculator",
          ),
          distSection,
          waterSection,
          p.sd || p.cord
            ? h(CordDiagram, {
                model: p.model,
                dist:
                  result && result.floored && p.cord === result.rec
                    ? result.swimAt
                    : p.sd,
                cord: p.cord,
                poolLen: p.poolLen,
                setback: p.setback,
              })
            : null,
        ),
        compatBox,
        resBox,
        result &&
          !result.long &&
          !result.short &&
          !result.tooClose &&
          !incompatible
          ? h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 11,
                  color: C.charcoal,
                  opacity: 0.6,
                  margin: "0 0 14px",
                },
              },
              "Override below if needed.",
            )
          : null,
      );
    }
    /* Show diagram even in manual mode if cord is selected */
    var manualDiagram =
      !p.uc && p.cord
        ? h(
            "div",
            { style: { marginTop: 14 } },
            h(CordDiagram, {
              model: p.model,
              dist: p.sd || "10",
              cord: p.cord,
              poolLen: p.poolLen,
              setback: p.setback,
            }),
          )
        : null;

    /* ── Swim-spa install picker: single = 6ft (Brent 2026-10-04, after three swim-spa owners found 4.5 too short), divide = 4.5ft, end-wall = 6ft ── */
    var IMGS = window.ST_INSTALL_IMAGES || {};
    var INSTALL_OPTS = [
      { key: "single", cord: 6, img: IMGS.single, label: "Single swim spa" },
      {
        key: "divide",
        cord: 4.5,
        img: IMGS.divide,
        label: "Dual-temp — divide-wall base",
      },
      {
        key: "endwall",
        cord: 6,
        img: IMGS.endwall,
        label: "Dual-temp — end-wall base",
      },
    ];
    var installCards = INSTALL_OPTS.map(function (o) {
      var sel = p.install === o.key;
      return h(
        "button",
        {
          key: o.key,
          onClick: function () {
            p.setCord(o.cord);
            p.setManualCord(true);
            p.setInstall(o.key);
          },
          style: {
            fontFamily: "inherit",
            cursor: "pointer",
            textAlign: "center",
            padding: "12px 10px 14px",
            borderRadius: 10,
            border: sel ? "2px solid " + C.blue : "1.5px solid " + C.ad,
            background: sel ? C.blue + "08" : C.white,
            boxShadow: sel ? "0 0 0 3px " + C.blue + "15" : "none",
            transition: "all .2s",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
          },
        },
        sel
          ? h(
              "span",
              {
                style: {
                  position: "absolute",
                  top: 6,
                  right: 8,
                  width: 20,
                  height: 20,
                  lineHeight: "20px",
                  textAlign: "center",
                  background: C.blue,
                  color: C.white,
                  borderRadius: "50%",
                  fontSize: 12,
                  fontWeight: 700,
                },
              },
              "✓",
            )
          : null,
        o.img
          ? h("img", {
              src: o.img,
              alt: o.label,
              loading: "lazy",
              style: {
                width: "100%",
                maxWidth: 150,
                height: "auto",
                display: "block",
                margin: "0 auto 8px",
              },
            })
          : null,
        h(
          "span",
          {
            style: {
              fontFamily: f,
              fontSize: 12,
              fontWeight: 700,
              color: C.graphite,
              lineHeight: 1.25,
            },
          },
          o.label,
        ),
        h(
          "span",
          {
            style: {
              fontFamily: f,
              fontSize: 11,
              fontWeight: 700,
              color: C.blue,
              marginTop: 4,
            },
          },
          (o.cord === 4.5 ? "4.5" : o.cord) + " ft cord",
        ),
      );
    });
    var swimSpaUI = h(
      "div",
      null,
      h(
        "p",
        {
          style: {
            fontFamily: bf,
            fontSize: 13,
            color: C.charcoal,
            margin: "0 0 12px",
          },
        },
        "Pick the setup that matches your swim spa — it sets your cord length.",
      ),
      h(
        "div",
        {
          style: {
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: 10,
          },
        },
        installCards,
      ),
      p.cord && p.install
        ? h(
            "p",
            {
              style: {
                fontFamily: f,
                fontSize: 13,
                fontWeight: 700,
                color: C.blue,
                margin: "14px 0 0",
              },
            },
            "✓ " + (p.cord === 4.5 ? "4.5" : p.cord) + " ft cord selected",
          )
        : null,
      h(
        "p",
        {
          style: {
            fontFamily: bf,
            fontSize: 12,
            color: C.charcoal,
            opacity: 0.7,
            margin: "14px 0 0",
          },
        },
        "Spa not pictured? ",
        h(
          "a",
          {
            href: "/pages/contact",
            style: {
              color: C.blue,
              fontWeight: 600,
              textDecoration: "underline",
            },
          },
          "Send us a photo",
        ),
        " and we’ll confirm your cord length.",
      ),
    );

    var poolUI = h(
      "div",
      null,
      h(
        "div",
        { style: { display: "flex", gap: 8, marginBottom: 20 } },
        togBtns,
      ),
      calcUI,
      h(
        "div",
        null,
        p.uc
          ? h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 11,
                  fontWeight: 600,
                  color: C.charcoal,
                  margin: "0 0 8px",
                  textTransform: "uppercase",
                  opacity: 0.5,
                },
              },
              "Or select manually:",
            )
          : null,
        h(
          "div",
          { style: { display: "flex", flexWrap: "wrap", gap: 6 } },
          cordBtns,
        ),
        p.cord
          ? h(
              "p",
              {
                style: {
                  fontFamily: bf,
                  fontSize: 11,
                  color: C.charcoal,
                  margin: "8px 0 0",
                  opacity: 0.6,
                },
              },
              "Selected: " + p.cord + "ft EPDM cord (Shore-A 60)",
            )
          : null,
        manualDiagram,
      ),
    );

    return p.setting === "swim_spa" ? swimSpaUI : poolUI;
  }

  function S4(p) {
    var m = MODELS[p.model],
      b = findBase(p.base);
    if (!m || !b || !p.cord) return null;
    var fitting = p.retro ? "narrow" : "standard";
    var pp = polePrice(p.model, fitting);
    /* Pricing model: pole variant price = kit ceiling (concrete baked in).
     Concrete and have_base both contribute $0 to the total.
     Threaded/Arctic add their full variant price as a paid upgrade.
     Cart total matches displayed total — no +10/-10 hacks. */
    var bp = p.base === "have_base" || b.inc ? 0 : basePrice(p.base);
    var ce = cordPriceFromShopify(p.cord);
    var tot = pp + bp + ce;
    var poleNote = p.retro ? " (Narrow Fitting)" : "";
    var baseDesc =
      p.base === "have_base"
        ? p.fit === "narrow"
          ? "Pole only \u2014 narrow fitting"
          : "Pole only \u2014 standard fitting"
        : b.desc;
    var lines = [
      {
        l: m.name + " Pole" + poleNote,
        d: m.height + '" \u00B7 ' + m.flex + '" flex',
        pr: pp,
      },
      { l: "Belt + Carabiner + Carry Bag", d: "Included", pr: 0 },
      {
        l: p.base === "have_base" ? "No Base (Using Existing)" : b.name,
        d: baseDesc,
        pr: bp,
      },
      {
        l: p.cord + "ft Stretch Cord",
        d: "EPDM Shore-A 60 \u00B7 Clips to 2ft belt tail",
        pr: ce,
      },
    ];
    /* Pending discount code: Shopify's own discount on this kit (see probePromo). */
    var promo = p.promo;
    var saved = promo ? promo.saved : 0;
    if (promo)
      promo.rows.forEach(function (r) {
        lines.push({
          l: "Code " + r.code,
          d: "Applied in your cart",
          pr: -r.amount,
        });
      });
    /* Couldn't price it (or the code takes effect at checkout, e.g. shipping):
       still say the code is waiting in the cart. A code Shopify says doesn't
       apply here gets no mention. */
    var codeNote = null;
    if (p.codes.length && !p.promoPending && !saved) {
      if (!promo)
        codeNote = "Code " + p.codes.join(", ") + " is applied in your cart.";
      else if (promo.applied.length)
        codeNote =
          "Code " + promo.applied.join(", ") + " is in your cart and applies at checkout.";
    }
    var rows = lines.map(function (ln, i) {
      return h(
        "div",
        {
          key: i,
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "13px 18px",
            borderBottom: i < lines.length - 1 ? "1px solid " + C.ad : "none",
            flexWrap: "wrap",
            gap: 4,
          },
        },
        h(
          "div",
          null,
          h(
            "p",
            {
              style: {
                fontFamily: f,
                fontSize: 13,
                fontWeight: 600,
                color: C.graphite,
                margin: "0 0 1px",
              },
            },
            ln.l,
          ),
          h(
            "p",
            {
              style: {
                fontFamily: bf,
                fontSize: 11,
                color: C.charcoal,
                margin: 0,
                opacity: 0.6,
              },
            },
            ln.d,
          ),
        ),
        h(
          "span",
          {
            style: {
              fontFamily: f,
              fontSize: 13,
              fontWeight: 600,
              color:
                ln.pr < 0 ? C.green : ln.pr === 0 ? C.charcoal : C.graphite,
              opacity: ln.pr === 0 ? 0.5 : 1,
            },
          },
          ln.pr === 0
            ? "Included"
            : ln.pr < 0
              ? "-$" + Math.abs(ln.pr).toFixed(2)
              : "$" + ln.pr.toFixed(2),
        ),
      );
    });
    var badges = [
      "Free US shipping over $99",
      "30-day guarantee",
      "1-year warranty",
    ].map(function (g, i) {
      return h(
        "div",
        { key: i, style: { display: "flex", alignItems: "center", gap: 5 } },
        h("span", { style: { fontSize: 11, color: C.green } }, "\u2713"),
        h(
          "span",
          { style: { fontFamily: bf, fontSize: 11, color: C.charcoal } },
          g,
        ),
      );
    });
    var kitSKU = buildKitSKU(p.model, p.cord, p.base, p.retro);
    return h(
      "div",
      null,
      h(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 16,
          },
        },
        h(
          "p",
          {
            style: {
              fontFamily: bf,
              fontSize: 14,
              color: C.charcoal,
              margin: 0,
            },
          },
          "Make sure everything looks right.",
        ),
        h(
          "span",
          {
            style: {
              fontFamily: "'Consolas','Courier New',monospace",
              fontSize: 12,
              fontWeight: 600,
              color: C.blue,
              background: C.arctic,
              border: "1px solid " + C.ad,
              borderRadius: 6,
              padding: "3px 10px",
              letterSpacing: 0.5,
            },
          },
          kitSKU,
        ),
      ),
      h(
        "div",
        {
          style: {
            background: C.arctic,
            borderRadius: 10,
            padding: "2px 0",
            marginBottom: 18,
            border: "1px solid " + C.ad,
          },
        },
        rows,
      ),
      codeNote
        ? h(
            "p",
            {
              style: {
                fontFamily: bf,
                fontSize: 12,
                fontWeight: 600,
                color: C.green,
                margin: "-8px 4px 16px",
              },
            },
            codeNote,
          )
        : null,
      h(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            padding: "0 4px",
            marginBottom: 20,
          },
        },
        h(
          "span",
          {
            style: {
              fontFamily: f,
              fontSize: 13,
              fontWeight: 600,
              color: C.charcoal,
              textTransform: "uppercase",
            },
          },
          "Total",
        ),
        h(
          "div",
          null,
          saved
            ? h(
                "span",
                {
                  style: {
                    fontFamily: f,
                    fontSize: 15,
                    fontWeight: 600,
                    color: C.charcoal,
                    opacity: 0.5,
                    textDecoration: "line-through",
                    marginRight: 8,
                  },
                },
                "$" + tot.toFixed(2),
              )
            : null,
          h(
            "span",
            {
              style: {
                fontFamily: f,
                fontSize: 26,
                fontWeight: 700,
                color: C.graphite,
              },
            },
            "$" + (tot - saved).toFixed(2),
          ),
        ),
      ),
      h(
        "div",
        { style: { display: "flex", gap: 14, flexWrap: "wrap" } },
        badges,
      ),
    );
  }

  /* Cart lines for a configured kit. Shared by Add to Cart and the discount
     probe, so the price Shopify quotes is for exactly what gets added. */
  function kitItems(model, base, cord, retro) {
    var m = MODELS[model],
      b = findBase(base);
    var fitting = retro ? "narrow" : "standard";
    var items = [];
    var bp = base === "have_base" || (b && b.inc) ? 0 : basePrice(base);
    var ce = cordPriceFromShopify(cord);
    /* Build kit contents list for pole properties */
    var kitParts = [];
    kitParts.push("Swim Belt");
    kitParts.push("Nylon Carry Bag");
    /* Every base ships a rubber base plug EXCEPT arctic (threads into the
       spa's factory receiver — no deck hole to cap). */
    if (base === "concrete" || base === "threaded" || base === "uha_cs" || base === "uha_bz")
      kitParts.push("Base Plug");
    /* Add-ons first (paid extras) so pole lands last in array.
     Shopify displays newest/last-added items at the top of the cart,
     so this ensures the kit (pole) always appears first.
     Bundled children carry _bundled_with = parent kit SKU so the cart template
     can hide them and roll their price into the kit line. */
    var kitSKU = buildKitSKU(model, cord, base, retro);
    /* — Cord (only if paid) */
    if (ce > 0) {
      var cVid = cordVariantId(cord);
      if (cVid)
        items.push({
          id: cVid,
          quantity: 1,
          properties: { "Cord Length": cord + " ft", _bundled_with: kitSKU },
        });
    }
    /* — Base: add to cart only when it's a paid upgrade (threaded/arctic).
     Concrete is baked into the pole price, so no separate line item.
     Fulfillment picks the base from the pole line's `Base: <name>` property.
     Cin7/SkuVault pack rules must include 1x BASE-CB + rubber plug whenever
     the pole line's `Base` property equals "Concrete Deck Base". */
    if (base !== "have_base" && bp > 0 && !b.inc) {
      var bVid = baseVariantId(base);
      if (bVid)
        items.push({
          id: bVid,
          quantity: 1,
          properties: { _bundled_with: kitSKU },
        });
    }
    /* — Pole (last = displays first in cart) */
    var baseName = base === "have_base" ? "Using Existing" : b.name;
    var poleProps = {
      "Kit Sku": kitSKU,
      Model: m.name,
      Fitting: retro ? "Narrow" : "Standard",
      "Cord Length": cord + " ft with Carabiner",
      Base: baseName,
    };
    if (kitParts.length > 0) poleProps["Includes"] = kitParts.join(", ");
    var pVid = poleVariantId(model, fitting);
    if (pVid) items.push({ id: pVid, quantity: 1, properties: poleProps });
    /* Belt + Bag are always included at $0 — no separate line items */
    return items;
  }

  function App() {
    /* â•â•â• Locked model mode: read from data-model attribute â•â•â• */
    var container = document.getElementById("st-configurator");
    var initLocked = container && container.getAttribute("data-model");
    /* ═══ URL SKU deep-link: ?sku=ST3-08-CB → pre-filled review ═══ */
    var urlSKU = (function () {
      try {
        var p = new URLSearchParams(window.location.search);
        return parseKitSKU(p.get("sku"));
      } catch (e) {
        return null;
      }
    })();
    /* ═══ URL setting: ?setting=swimspa → pre-select the swim-spa cord branch ═══ */
    var urlSetting = (function () {
      try {
        var q = new URLSearchParams(window.location.search).get("setting");
        if (q === "swimspa" || q === "swim-spa") return "swim_spa";
        if (q === "pool") return "pool";
      } catch (e) {}
      return "pool"; /* default fork: Pool selected on load (swim-spa arrives via ?setting=swimspa) */
    })();

    /* If URL SKU present, override locked model — use full flow at review step */
    var _lk = useState(
        urlSKU ? null : initLocked && MODELS[initLocked] ? initLocked : null,
      ),
      lockedModel = _lk[0],
      setLockedModel = _lk[1];
    var isLocked = !!lockedModel;

    var _a = useState(!REQUIRE_ACCESS_CODE),
      auth = _a[0],
      setAuth = _a[1];
    /* Full SKU (with base) → jump to Review. Partial SKU (no base) → land on Base step so user can pick one. */
    var _s = useState(urlSKU ? (urlSKU.hasBase ? 3 : 1) : 0),
      step = _s[0],
      setStep = _s[1];
    var _m = useState(urlSKU ? urlSKU.model : lockedModel || null),
      model = _m[0],
      setModel = _m[1];
    var _b = useState(urlSKU ? urlSKU.base : null),
      base = _b[0],
      setBase = _b[1];
    var _c = useState(urlSKU ? urlSKU.cord : null),
      cord = _c[0],
      setCord = _c[1];
    var _d = useState(""),
      sd = _d[0],
      setSD = _d[1];
    var _h = useState(false),
      ho = _h[0],
      setHO = _h[1];
    var _o = useState(""),
      oh = _o[0],
      setOH = _o[1];
    var _p = useState(""),
      od = _p[0],
      setOD = _p[1];
    /* If URL brought a cord (from cord calculator), default to "I know what I need" tab so the pre-selected cord shows highlighted instead of the calculator re-asking. */
    var _u = useState(!(urlSKU && urlSKU.cord)),
      uc = _u[0],
      setUC = _u[1];
    var _f = useState(urlSKU ? urlSKU.fitting : "standard"),
      fit = _f[0],
      setFit = _f[1];
    var _pl = useState(""),
      poolLen = _pl[0],
      setPoolLen = _pl[1];
    var _sb = useState(""),
      setback = _sb[0],
      setSetback = _sb[1];
    var _ac = useState(false),
      autoCalc = _ac[0],
      setAutoCalc = _ac[1];
    var _mc = useState(!!(urlSKU && urlSKU.cord)),
      manualCord = _mc[0],
      setManualCord = _mc[1];
    var _set = useState(urlSetting),
      setting = _set[0],
      setSetting = _set[1];
    var _inst = useState(null),
      install = _inst[0],
      setInstall = _inst[1];
    var _wf = useState(""),
      wFt = _wf[0],
      setWFt = _wf[1];
    var _wi = useState(""),
      wIn = _wi[0],
      setWIn = _wi[1];
    var _ws = useState(false),
      wStd = _ws[0],
      setWStd = _ws[1];
    var topRef = useRef(null);
    var retro = base === "have_base" && fit === "narrow";

    /* Pending discount code → Shopify's price for this kit (fix-it #87). */
    var _cd = useState(cookieCodes),
      codes = _cd[0],
      setCodes = _cd[1];
    var _pr = useState(null),
      promoState = _pr[0],
      setPromoState = _pr[1];
    var promoKey = useRef("");
    useEffect(function () {
      if (codes.length) return;
      /* No cookie: a code typed into the cart drawer still counts. */
      var r0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(r0 + "cart.js")
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (cart) {
          var cs = ((cart && cart.discount_codes) || [])
            .map(function (d) {
              return d.code;
            })
            .filter(Boolean);
          if (cs.length) setCodes(cs);
        })
        .catch(function () {});
    }, []);
    var promoItems =
      codes.length && model && MODELS[model] && cord && base && findBase(base)
        ? kitItems(model, base, cord, retro)
        : [];
    var promoId = promoItems.length
      ? JSON.stringify([
          promoItems.map(function (i) {
            return i.id;
          }),
          codes,
        ])
      : "";
    useEffect(
      function () {
        promoKey.current = promoId;
        if (!promoId) return;
        setPromoState({ key: promoId, pending: true, res: null });
        probePromo(promoItems, codes, function (res) {
          if (promoKey.current === promoId)
            setPromoState({ key: promoId, pending: false, res: res });
        });
      },
      [promoId],
    );
    var promo = promoState && promoState.key === promoId ? promoState : null;
    var promoPending = !!promoId && (!promo || promo.pending);
    var promoRes = promo && !promo.pending ? promo.res : null;

    /* Adjust steps for locked mode: skip model selection */
    var allLabels = ["Model", "Base", "Cord", "Review"];
    var labels = isLocked ? ["Base", "Cord", "Review"] : allLabels;
    var totalSteps = isLocked ? 3 : 4;
    /* Map display step to actual content */
    function actualStep() {
      return isLocked ? step + 1 : step;
    }
    var canNext = isLocked
      ? [
          function () {
            return (
              !!base &&
              (base !== "have_base" || fit === "standard" || fit === "narrow")
            );
          },
          function () {
            return !!cord;
          },
          function () {
            return true;
          },
        ]
      : [
          function () {
            return !!model;
          },
          function () {
            return (
              !!base &&
              (base !== "have_base" || fit === "standard" || fit === "narrow")
            );
          },
          function () {
            return !!cord;
          },
          function () {
            return true;
          },
        ];
    function goN() {
      setStep(function (s) {
        return Math.min(s + 1, totalSteps - 1);
      });
      if (topRef.current) topRef.current.scrollIntoView({ behavior: "smooth" });
    }
    function goB() {
      setStep(function (s) {
        return Math.max(s - 1, 0);
      });
      if (topRef.current) topRef.current.scrollIntoView({ behavior: "smooth" });
    }
    function addToCart() {
      var m = MODELS[model],
        b = findBase(base);
      var fitting = retro ? "narrow" : "standard";
      var bp = base === "have_base" || (b && b.inc) ? 0 : basePrice(base);
      var ce = cordPriceFromShopify(cord);
      var items = kitItems(model, base, cord, retro);
      /* Check all variant IDs resolved */
      var hasIds =
        items.length > 0 &&
        items.every(function (i) {
          return i.id > 0;
        });
      if (!hasIds) {
        var pp = polePrice(model, fitting);
        alert(
          "Kit Summary\n\n" +
            m.name +
            (retro ? " (Narrow Fitting)" : "") +
            "\n" +
            (base === "have_base" ? "Using existing base" : b.name) +
            "\n" +
            cord +
            "ft cord\nTotal: $" +
            (pp + bp + ce).toFixed(2) +
            "\n\nVariant IDs not yet configured.\nCreate products in Shopify and update SKUs in configurator.liquid",
        );
        return;
      }
      // Keep the market subfolder (/en-au/ …) or the cart flips to USD.
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok)
            return r.json().then(function (d) {
              throw new Error(d.description || d.errors || "Cart error");
            });
          return r.json();
        })
        .then(function () {
          window.location.href = root + "cart";
        })
        .catch(function (err) {
          alert(
            "Error adding to cart: " +
              err.message +
              "\n\nPlease try again or contact us for help.",
          );
          console.error(err);
        });
    }
    if (!auth)
      return h(Gate, {
        onOk: function () {
          setAuth(true);
        },
      });
    var activeFit = retro ? "narrow" : "standard";
    var tpB = base ? findBase(base) : null;
    var tp = model
      ? polePrice(model, activeFit) +
        (base === "have_base" || (tpB && tpB.inc)
          ? 0
          : base
            ? basePrice(base)
            : 0) +
        cordPriceFromShopify(cord || 0)
      : 0;
    var content;
    var as = actualStep();
    if (as === 0) content = h(S1, { model: model, set: setModel });
    else if (as === 1)
      content = h(S2, {
        base: base,
        set: setBase,
        model: model,
        fit: fit,
        setFit: setFit,
      });
    else if (as === 2)
      content = h(S3, {
        model: model,
        cord: cord,
        setCord: setCord,
        sd: sd,
        setSD: setSD,
        ho: ho,
        setHO: setHO,
        oh: oh,
        setOH: setOH,
        od: od,
        setOD: setOD,
        uc: uc,
        setUC: setUC,
        poolLen: poolLen,
        setPoolLen: setPoolLen,
        setback: setback,
        setSetback: setSetback,
        autoCalc: autoCalc,
        setAutoCalc: setAutoCalc,
        manualCord: manualCord,
        setManualCord: setManualCord,
        setting: setting,
        setSetting: setSetting,
        install: install,
        setInstall: setInstall,
        wFt: wFt,
        wIn: wIn,
        wStd: wStd,
        setWater: setWater,
        onModelSwap: handleModelSwap,
      });
    else
      content = h(S4, {
        model: model,
        base: base,
        cord: cord,
        retro: retro,
        fit: fit,
        codes: codes,
        promo: promoRes,
        promoPending: promoPending,
      });

    var headerTitle = isLocked
      ? "Build Your " + MODELS[lockedModel].name + " Kit"
      : "Build Your Kit";

    /* Expose stSelectModel so model cards can lock a model dynamically */
    window.stSelectModel = function (key) {
      if (MODELS[key]) {
        setLockedModel(key);
        setModel(key);
        setStep(0);
        setBase(null);
        setCord(null);
        setSD("");
        setHO(false);
        setOH("");
        setOD("");
        setUC(true);
        setFit("standard");
        setPoolLen("");
        setSetback("");
        setAutoCalc(false);
        setManualCord(false);
        setInstall(null);
      }
    };

    /* Change Model handler: unlock and show full 4-step flow */
    function changeModel() {
      setLockedModel(null);
      setModel(null);
      setBase(null);
      setCord(null);
      setSD("");
      setHO(false);
      setOH("");
      setOD("");
      setUC(true);
      setFit("standard");
      setPoolLen("");
      setSetback("");
      setAutoCalc(false);
      setManualCord(false);
      setStep(0);
      if (topRef.current) topRef.current.scrollIntoView({ behavior: "smooth" });
    }

    /* Hot-swap model from cord step compatibility check */
    function handleModelSwap(newModel) {
      setModel(newModel);
      if (isLocked) setLockedModel(newModel);
      setCord(null);
      setManualCord(false);
      setInstall(null);
    }

    /* Fork choice resets downstream base/fitting/cord (e.g. arctic is invalid for pool). */
    function chooseSetting(v) {
      setSetting(v);
      setBase(null);
      setFit("standard");
      setCord(null);
      setManualCord(false);
      setInstall(null);
      setSD("");
      setPoolLen("");
      setSetback("");
      setAutoCalc(false);
      setUC(true);
      setWFt("");
      setWIn("");
      setWStd(false);
    }
    /* base->water from feet+inches, or the standard 8-10in deck gap (~9in). */
    function setWater(ft, inch, std) {
      setWFt(ft);
      setWIn(inch);
      setWStd(std);
      var v = std ? 0.5 : (parseFloat(ft) || 0) + (parseFloat(inch) || 0) / 12;
      setSetback(v ? String(v) : "");
    }

    /* Progressive reveal: sections stack vertically; each reveals once the prior is complete. */
    var stepNum = 0;
    function labelFor(title) {
      stepNum++;
      return stepNum + " \u00B7 " + title;
    }
    var sectionLabelStyle = {
      fontFamily: f,
      fontSize: 11,
      fontWeight: 700,
      color: C.charcoal,
      margin: "0 0 14px",
      textTransform: "uppercase",
      letterSpacing: ".1em",
      opacity: 0.7,
    };
    function section(title, content) {
      return h(
        "div",
        { style: { marginBottom: 36 } },
        h("p", { style: sectionLabelStyle }, labelFor(title)),
        content,
      );
    }
    var fitOK =
      base && (base !== "have_base" || fit === "standard" || fit === "narrow");
    var baseFitOK = !!setting && !!base && fitOK;
    var showBase = !!setting;
    var showPole = baseFitOK && !isLocked;
    var showCord = baseFitOK && !!model;
    var showReview = showCord && !!cord;
    return h(
      "div",
      { ref: topRef, style: { maxWidth: 720, margin: "0 auto" } },
      isLocked
        ? h(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                marginBottom: 22,
                flexWrap: "wrap",
                gap: 8,
              },
            },
            h(
              "p",
              {
                style: {
                  fontFamily: f,
                  fontSize: 13,
                  fontWeight: 600,
                  color: C.graphite,
                  margin: 0,
                },
              },
              "Building: ",
              h("span", { style: { color: C.blue } }, MODELS[lockedModel].name),
            ),
            h(
              "button",
              {
                onClick: changeModel,
                style: {
                  fontFamily: bf,
                  fontSize: 12,
                  color: C.blue,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 500,
                  textDecoration: "underline",
                },
              },
              "Change model",
            ),
          )
        : null,
      section(
        "Where will you use it?",
        h(S0, { setting: setting, choose: chooseSetting }),
      ),
      showBase
        ? section(
            "Your base & fitting",
            h(S2, {
              setting: setting,
              base: base,
              set: setBase,
              model: model,
              fit: fit,
              setFit: setFit,
            }),
          )
        : null,
      showPole
        ? section("Pick your model", h(S1, { model: model, set: setModel }))
        : null,
      showCord
        ? section(
            "Pick cord length",
            h(S3, {
              model: model,
              cord: cord,
              setCord: setCord,
              sd: sd,
              setSD: setSD,
              ho: ho,
              setHO: setHO,
              oh: oh,
              setOH: setOH,
              od: od,
              setOD: setOD,
              uc: uc,
              setUC: setUC,
              poolLen: poolLen,
              setPoolLen: setPoolLen,
              setback: setback,
              setSetback: setSetback,
              autoCalc: autoCalc,
              setAutoCalc: setAutoCalc,
              manualCord: manualCord,
              setManualCord: setManualCord,
              setting: setting,
              setSetting: setSetting,
              install: install,
              setInstall: setInstall,
              wFt: wFt,
              wIn: wIn,
              wStd: wStd,
              setWater: setWater,
              onModelSwap: handleModelSwap,
            }),
          )
        : null,
      showReview
        ? h(
            "div",
            null,
            section(
              "Review",
              h(S4, {
                model: model,
                base: base,
                cord: cord,
                retro: retro,
                fit: fit,
                codes: codes,
                promo: promoRes,
                promoPending: promoPending,
              }),
            ),
            h(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "center",
                  marginTop: -8,
                  marginBottom: 16,
                },
              },
              h(
                Btn,
                { pri: true, onClick: addToCart },
                "Add to Cart \u2014 $" +
                  (tp - (promoRes ? promoRes.saved : 0)).toFixed(2),
              ),
            ),
          )
        : null,
      h(
        "p",
        {
          style: {
            textAlign: "center",
            fontFamily: bf,
            fontSize: 12,
            color: C.charcoal,
            opacity: 0.6,
            margin: "32px 0 0",
          },
        },
        "Not sure? ",
        h(
          "a",
          {
            href: "/pages/contact",
            style: { color: C.blue, textDecoration: "none", fontWeight: 600 },
          },
          "Contact us",
        ),
        " and we\u2019ll help.",
      ),
    );
  }

  var root = document.getElementById("st-configurator");
  if (root) ReactDOM.createRoot(root).render(h(App));
})();
